/* global dataLayer */
/* global Blob */
import axios from 'axios';
import Hashids from 'hashids';
import moment from 'moment-timezone';
import router from '../router';
import storejs from 'store';
import _ from 'lodash';
import { encodeURI } from 'js-base64';
import { inDevEnvironment } from '@utilities/helpers';
import {
  PLAYPOSIT_API_ENDPOINTS,
  INTERACTION_TYPES,
} from '@Constants';

const hashids = new Hashids('dachshund', 6, 'cdefhjkmnprtvwxy2345689');

//instructor specicific state
const state = {
    //nav control for instructors
    activeViewInstructor: null,
    courseWorkId: null,
    enableGrading: null,
    gradebookBreadcrumbs: [],
    initialView: null,

    //toggle for data load
    instructorAjaxing: false,
    editGrades: false,
    refreshData: false,
    dynamicDataLoaded: false,
    toastLoader: {
      toggle: false,
      text: ''
    },
    editLMBRubric: false,
    reloadInteractionViewerId : null,
    permissionPending: false,
    playlistModalLoading: false,
    playlistSections: [],

    //interactive instructor data
    addEmailList: [],
    selectedData: [],
    selectedUser: null,
    multiSelect: false,
    saveCount: 0,
    savedGrade: null,
    queryParamsInstructors: {
        page: 1,
        per_page: 20,
        search: '',
        sort: '',
        section_id: '',
        bulb_id: '',
        interaction_id: '',
        interaction_type: '',
        student_id: '',
        folder_id: '',
        subfolder_id: '',
        lms_class: false,
        lmb_bulb: '',
        lmb_section: '',
    },
    activeIcon: null,
    // filter Interactions
    filtersInteraction: {
      selectedStatus: '',
      status: ['All', 'Completed', 'In Progress', 'Not Started'],
      filteredBy: '',
      isFiltered: false
    },
    //filter data
    filterSearch: {
      contentType: 'Bulbs',
      creator_id: '',
      creator_name: '',
      age: [],
      subject: [],
      keywords: [],
      name: [],
      creator: [],
      bulbRole: [],
      youtube: '',
      bulbId:'',
      all_district: true,
      legacy: false,
      tagExactMatch: false,
      excludeTags: [],
      playlistRole: [],
      playlistId: [],
    },
    tags: {
      age: [],
      subject: [],
      keywords: [],
      rawData: [],
    },
    filterString: '',
    //table data
    classes: {
        archived: false,
        pagination: {
            total: 0,
        },
        data: [],
    },
    bulbs: {
        pagination: {
            total: 0,
        },
        data: [],

    },
    videos: {
        pagination: {
            total: 0,
        },
        data: [],
    },
    folders: {
        pagination: {
            total: 0,
        },
        data: [],
    },
    singlefolder: {
        pagination: {
            total: 0,
        },
        data: [],
    },
    subfolder: {
        pagination: {
            total: 0,
        },
        data: [],
    },
    students: {
        pagination: {
            total: 0,
        },
        data: [],
    },
    premade: {
        pagination: {
            total: 0,
        },
        data: [],
        type: 'bulbs',
    },
    playlists: {
        pagination: {
            total: 0,
        }
    },
    community: {
        pagination: {
            total: 0,
        },
        data: [],
        type: 'bulbs',
    },
    bulbattempts: {
        pagination: {
            total: 0,
        },
        data: [],
    },
    gradebook: {
        pagination: {
            total: 0,
        },
        headers:[],
        data: [],
    },
    interactions: {
        pagination: {
            total: 0,
        },
        headers:[],
        data: [],
        answeredBankIds: [],
    },
    studentbulbattempts: {
        pagination: {
            total: 0,
        },
        data: [],
    },
    singleinteraction: {
        pagination: {
            total: 0,
        },
        headers: {},
        data: [],
    },
    studentinteraction: {
        pagination: {
            total: 0,
        },
        data: [],
    },
    lmb: {
        pagination: {
            total: 0,
        },
        headers: {},
        data: [],
    },
    peerreview: {
        pagination: {
            total: 0,
        },
        headers: {},
        data: [],
    },
    groups: {
      data:[]
    },
    groupSets: [
    
    ],
    //popup data
    assignedBulbSections: {},
    assignedDates: {},
    assignedDatesOriginal: {},
    assignedGroupSets: {},
    bulbSections: null,
    playlistAssignedDates: {},
    
    importLogs: [],
    importLogsLoading: false,
    foldersBulb: {
      folders: [],
      folders_bulb:{}
    },

    // Bulb Summary Analytics
    bulbAnalytics: null,
    bulbAnalyticsSummaryChart: {
      // we should eventually update this let the route return the chart.js object with colors
      labels:[],
      datasets: [
        {
          label:['Correct'],
          backgroundColor: 'rgba(76,175,80, .7)', // GREEN
          data:[],
          icons:[],
        },
        {
          label:['Incorrect'],
          backgroundColor: 'rgba(244,67,54, .7)', // RED
          data:[]
        },
        {
          label:['Ungraded'],
          backgroundColor: 'rgba(239,186,44, .7)', // YELLOW
          data:[]
        }]
    },
    summaryChartKey: 1,
    bulbHasNoSummaryData: false,
    // Bulb Average Score Analytics
    bulbAverageScoreChart: {
      labels: ['100%', '75%-99%', '50%-74%', '<50%'],
      datasets: [
        {
          fill: true,
          backgroundColor: ['#104673', '#2196F3', '#6CB7F4' , '#526975'],  // PP blues
          data: []
        }
        ]
    },
    averageChartKey: 1,
    bulbHasNoAverageData: false,
    // Bulb Complete Analytics
    bulbCompleteChart: {
      labels: ['Completed', 'In Progress', 'Not Started'],
      datasets: [
        {
          fill: true,
          backgroundColor: ['#104673', '#2196F3', '#6CB7F4'], // PP blues
          data: []
        }
        ]
    },
    completeChartKey: 1,
    bulbHasNoCompleteData: false,
    // CoOwners Search
    emailMatchesFromSchool: [],
    searchingForEmailMatch: false,
    bulbCoOwners: [],
    playlistAverage: false,
    playlistCoOwners: [],
    classCoOwners: [],
    coOwnersKey: 1,
    embedded: false,
    pingSuccess: false,
    sectionHasPlaylist: false,
    sectionPlaylists: null,
    showPointsMode: false,
    premadeFilterContentType: 'Bulbs',
    instructorBatchLoading: false,
};

const mutations = {
  //nav and interactive state mutations
  setActiveView(state, array){
    //sets instructor active view
    // [ ] update to just pass the value that gets to set activeViewInstructor
    state.activeViewInstructor= array[0];
  },
  setGradebookBreadcrumbs(state, breadcrumbs) {
    //set gradebook breadcrumbs
    state.gradebookBreadcrumbs= breadcrumbs
  },
  setInitialView(state, view) {
    state.initialView = view;
  },
  setQueryParams(state, object) {
      //merge old and new query params to newParam object
      let queryParams = state.queryParamsInstructors;
      let newParams = Object.assign(queryParams, object);
      //sets query params to new object
      state.queryParamsInstructors = newParams;
    },
    setEmbedded(state, value) {
      state.embedded = value;
    },
    resetQueryParams(state){
      //reset query params back to
      state.queryParamsInstructors = {
        page: 1,
        per_page: 20,
        search: '',
        sort: '',
        all_data: true,
        section_id: '',
        bulb_id: '',
        interaction_id: '',
        interaction_type: '',
        student_id: '',
        folder_id: '',
        subfolder_id: '',
        lms_class: false,
        lmb_bulb: '',
        lmb_section: '',
        playlistAssign: null,
        playlistGradebook: null,
        // filter_status:'',
      }
    },

    //toggle mutations
    toggleEditGrades(state, boolean){
      //turn on and off grade mode
      state.editGrades = boolean;
    },
    toggleToastLoader(state, data){
      state.toastLoader.toggle = data.toggle;
      state.toastLoader.text= data.text;
    },
    refreshData(state){
      //trigger data refresh after an update, creation, or deletion
      state.refreshData = true;
    },
    refreshComplete(state){
      //turn off data refresh
      state.refreshData = false;
    },
    setAddEmailList (state, values) {
      for (const email of values) {
        state.addEmailList.push(email);
      }
    },
    setBulbHasNoSummaryData (state, value) {
      state.bulbHasNoSummaryData = value;
    },
    setBulbHasNoAverageData (state, value) {
      state.bulbHasNoAverageData = value;
    },
    setBulbHasNoCompleteData (state, value) {
      state.bulbHasNoCompleteData = value;
    },
    setEmailMatchesFromSchool (state, value) {
      state.emailMatchesFromSchool = value;
    },
    setBulbCoOwners (state, value) {
      for (const coOwner of value) {
        state.bulbCoOwners.push(coOwner);
      }
    },
    setPermissionPending(state, value) {
      state.permissionPending = value;
    },
    setPlaylistCoOwners (state, value) {
      for (const coOwner of value) {
        state.playlistCoOwners.push(coOwner);
      }
    },
    setMultiSelect (state, value) {
      state.multiSelect = value;
    },
    setSavedGrade (state, value) {
      state.savedGrade = value;
      state.saveCount += 1;
    },
    resetAddEmailList(state) {
      state.addEmailList = [];
    },
    resetBulbCoOwners (state) {
      state.bulbCoOwners = [];
    },
    resetPlaylistCoOwners (state) {
      state.playlistCoOwners = [];
    },
    resetClassCoOwners (state) {
      state.classCoOwners = [];
    },
    incrementCoOwnersKey (state) {
      state.coOwnersKey += 1;
    },
    setClassCoOwners (state, value) {
      for (const coOwner of value) {
        state.classCoOwners.push(coOwner);
      }
    },
    setPingSuccess (state, value) {
      state.pingSuccess = value;
    },
    //class data function
    setClasses(state, response) {
      //sets class data in initial mount- class data is used in assigning popups outside the class table
      //sets rows per page based on total
      let rowsPerPage = [];
      if (response.msg === 'success') {
        if(response.data.total <= 20) rowsPerPage = [response.data.total];
        if(response.data.total > 20 && response.data.total <= 40) rowsPerPage = [20, response.data.total];
        if(response.data.total > 40 && response.data.total <= 60) rowsPerPage = [20, 40, response.data.total];
        if(response.data.total > 40 ) rowsPerPage = [ 20, 40, 60, response.data.total];

        //sets data and pagination
        state.classes.data = response.data.data;
        state.classes.pagination.total = response.data.total;
        state.classes.pagination.rowsPerPage = rowsPerPage;
      } else state.classes = response;
    },

    //mutations to set table data
    setTableData(state, object) {

      //reset enable grading
      state.enableGrading = null;

      //sets data based on ajax routes
      switch (object.route) {
        case 'gradebook':
          //sets gradebook data and pagination
          state.gradebook.pagination = {
            total : object.data.total,
          };
          state.gradebook.headers = object.data.headers;
          state.gradebook.data = object.data.data;
          break;
        case 'interactions':
          state.courseWorkId = object.data.courseWorkId;
          state.enableGrading = Array.isArray(object?.data?.enable_grading?.data) // due to LTI 1.3 schema differences...
            ? object?.data?.enable_grading?.data?.[0]
            : object?.data?.enable_grading;
        case 'lmbmonitor':
          //sets interaction data and pagination
          state.interactions.pagination = {
            total : object.data.total,
          };
          state.interactions.headers = object.data.headers;
          //parse status of bulb attempt
          object.data.data.map(item => {
            if(!item.complete && item.complete != 0){
              item.status = 'Not started';
            } else if(item.complete === 1) {
              item.status = `Completed in ${moment.duration(item.time_elapsed,"seconds").humanize()}`;
            } else if (item.complete === 0) {
              item.status = `In progress for ${moment.duration(item.time_elapsed,"seconds").humanize()}`;
            }
          })

          state.interactions.data = object.data.data;
          if (object.data.answeredBankIds) state.interactions.answeredBankIds = object.data.answeredBankIds;
          break;
        case 'bulbattempts':
          //sets bulb attempt data and pagination
          state.studentbulbattempts.pagination = {
            total : object.data.total,
          };
          //parse status of bulb attempt
          object.data.data.map(item => {
            if(!item.complete && item.complete !=0){
              item.status = 'Not Started';
            } else if(item.complete === 1) {
              item.status = `Completed on ${moment.tz(item.completion_time, object.tz).format("MMM DD, YYYY hh:mm A z")}`;
            } else if (item.complete === 0) {
              item.status = 'In Progress';
            }
          })

          state.studentbulbattempts.data = object.data.data;
          break;
        case 'singleinteraction':
          // sets single interaction for multiple student data and pagination
          state.singleinteraction.pagination = {
            total : object.data.total,
          };
          state.singleinteraction.data = object.data.data;
          state.singleinteraction.headers = object.data.headers;
          break;
        case 'studentinteraction':
          //sets interaction data for a single student and single bulb and pagination
          state.studentinteraction.pagination = {
            total : object.data.total,
          };
          state.studentinteraction.data = object.data.data;
          break;
        case 'bulbs':
          //sets bulb data for specific section_id and pagination
          state.bulbs.pagination = {
            total : object.data.total,
          };

          // Parse date assigned and returns "No Date Assigned" if null
          object.data.data.map(item => {
            if (item.assigned_date) {
              // The bulb's assigned date comes back in UTC format so we need to convert it to the intstructors timezone:
              item.assigned_date = moment.tz(item.assigned_date, object.tz).format("MMM DD, YYYY hh:mm A");
            } else {
              item.assigned_date = 'No Date Assigned';
            }
          });

          // This modifies the returned bulb array to add the linked piece of LTI content as the first
          // bulb to display in the list.
          filterLtiLinkedContent(object);

          state.bulbs.data = object.data.data;
          break;
        case 'classes':
          //sets class table data and pagination
          state.classes.pagination = {
            total : object.data.total,
          };
          state.classes.data = object.data.data;
          break;
        case 'folders':
          //sets unit table data and pagination
          state.folders.pagination = {
            total : object.data.total,
          };
          state.folders.data = object.data.data;
          break;
        case 'singlefolder':
          //sets unit table data and pagination
          state.singlefolder.pagination = {
            total : object.data.total,
          };
          state.singlefolder.data = object.data.data;
          break;
        case 'subfolder':
          //sets unit table data and pagination
          state.subfolder.pagination = {
            total : object.data.total,
          };
          state.subfolder.data = object.data.data;
          break;
        case 'students':
          //sets student table data and pagination
          state.students.pagination = {
            total : object.data.total,
          };
          state.students.data = object.data.data;
          break;
        case 'premade':
          //sets premade bulb table data and pagination
          if (state.premadeFilterContentType === 'Bulbs') {
            state.premade.pagination = {
              total : object.data.total,
            };
            state.premade.type = 'bulbs';
          } else {
            state.premade.pagination = object.data.pagination;
            state.premade.type = 'playlists';
          }
          state.premade.data = object.data.data;
          break;
        case 'playlists':
          filterLtiLinkedContent(object);
          state.playlists = object.data;
          break;
        case 'videos':
          //sets premade bulb table data and pagination
          state.videos.pagination = {
            total : object.data.total,
          };
          state.videos.data = object.data.data;
          break;
        case 'community':
          //sets premade bulb table data and pagination
          if (state.premadeFilterContentType === 'Bulbs') {
            state.community.pagination = {
              total : object.data.total,
            };
            state.community.type = 'bulbs';
          } else {
            state.community.pagination = object.data.pagination;
            state.community.type = 'playlists';
          }
          state.community.data = object.data.data;
          break;
        case 'lmb':
          //sets premade bulb table data and pagination
          state.lmb.pagination = {
            total : object.data.total,
          };

          // Grading always true for lmb
          state.enableGrading = 1;

          state.lmb.headers = object.data.headers[0];

          //parse status of bulb attempt
          object.data.data.map(item => {
            if(!item.complete && item.complete !=0){
              item.status = 'Not Started';
            } else if(item.complete === 1) {
              item.status = `Completed on ${moment.tz(item.completion_time, object.tz).format("MMM DD, YYYY hh:mm A z")}`;
            } else if (item.complete === 0) {
              item.status = 'In Progress';
            }
          })

          state.lmb.data = object.data.data;
          break;
        case 'peerreview':
          //sets premade bulb table data and pagination
          state.peerreview.pagination = {
            total : object.data.total,
          };

          if (object.data.headers) {
            state.peerreview.headers = object.data.headers[0];
          } else if (object.data.searchResponse.headers) {
            state.peerreview.headers = object.data.searchResponse.headers[0];
          }
          
          const data = object.data.data ? object.data.data : object.data.searchResponse.data;
          
          // Grading always true for peer review
          state.enableGrading = 1;

          //parse status of bulb attempt
          data.map(item => {
            if(!item.complete && item.complete !=0){
              item.submissionStatus = 'Not Started';
            } else if(item.complete === 1) {
              item.submissionStatus = "Complete";
            } else if (item.complete === 0) {
              item.submissionStatus = 'In Progress';
            }

            item.peerReviewStatus;
            if(item.peer_review_status.length === 0){
              item.peerReviewStatus = 'Not Started'
            } else {
              let not_started = 0;
              let in_progress = 0;
              let completed = 0;
              item.peer_review_status.forEach(stu => {
                if(stu.complete === null){
                  not_started += 1
                } else if(stu.complete === 0){
                  in_progress += 1
                } else {
                  completed += 1
                }
              })

              if(completed === item.peer_review_status.length){
                item.peerReviewStatus = 'Complete'
              } else if(not_started === item.peer_review_status.length){
                item.peerReviewStatus = 'Not Started'
              } else {
                item.peerReviewStatus = 'In Progress'
              }
            }
          })

          state.peerreview.data = data;
          break;
        default:
          break;
      }
      state.dynamicDataLoaded = true;
    },
    // mutation to set a section's Playlists
    setSectionPlaylists(state, playlists) {
      state.sectionPlaylists = playlists;
    },
    //mutation to manage selected data
    setSelectedData(state, array){
      //sets selected data from table selection column
      state.selectedData = array;
    },
    setSelectedUser(state, value) {
      //sets selected user in collaborate menu
      state.selectedUser = value;
    },

    setPremadeFilterContentType(state, value) {
      state.premadeFilterContentType = value;
    },
    //mutations to manage popup data
    setAssignedDates(state, bulbSections) {
      try {
          //set assigned dates for each class for specific bulb_id
        const dates = {}; // map of { sectionId: assignedDate }
        const groups = {}; // map of { sectionId: assignedGroupSet }
        const bulbSectionIds = {}; // map of {sectionId: bulbSectionId }
        if (bulbSections.length > 0) {
          //if data, create object with each assigned date saved to the section_id
          // if we combine them into a single array of bulbSection objects we would need to build one for every potential one
          bulbSections.forEach(bs => {
            dates[bs.section_id] = bs.assigned_date;
            groups[bs.section_id] = bs.group_set_id;
            bulbSectionIds[bs.section_id] = bs.bulb_section_id;
          })
        }
        //save object to state
        state.assignedDates = dates;
        state.assignedGroupSets = groups;
        state.assignedBulbSections = bulbSectionIds;
        state.bulbSections = bulbSections;
      } catch (err) {
        console.log(err)
      }
    },
    setPlaylistAssignedDates(state, sections) {
      state.playlistAssignedDates = sections;
    },
    setPlaylistSections(state, sections) {
      state.playlistSections = sections;
    },
    setImportLogs(state, array) {
      state.importLogs = array;
      state.importLogsLoading = false;
    },
    setFiltersInteractions(state, options) {
      // set filters in interactions bulbattempts
      state.filtersInteraction.selectedStatus = options.selectedStatus;
      state.filtersInteraction.showPointsBadges = options.showPointsBadges;
      state.filtersInteraction.localShowPointsBadges = options.localShowPointsBadges;
      state.filtersInteraction.isFiltered = options.isFiltered;
      state.refreshData = options.refreshData;
    },
    setFilters(state, obj) {
      state.filterSearch.age = obj.age ? obj.age : '';
      state.filterSearch.contentType = obj.contentType ? obj.contentType : '';
      state.filterSearch.subject = obj.subject ? obj.subject : [];
      state.filterSearch.legacy = obj.legacy ? obj.legacy : false;
      state.filterSearch.all_district = obj.all_district ? obj.all_district : true;
      state.filterSearch.keywords = obj.keywords ? obj.keywords : [];
      state.filterSearch.youtube = obj.youtube ? obj.youtube : '';
      state.filterSearch.name = obj.name ? obj.name : [];
      state.filterSearch.creator = obj.creator ? obj.creator : '';
      state.filterSearch.creator_id = obj.creator_id ? obj.creator_id : '';
      state.filterSearch.bulbRole = obj.bulbRole ? obj.bulbRole : [];
      state.filterSearch.tagExactMatch = obj.tagExactMatch ? obj.tagExactMatch : false;
      state.filterSearch.bulbId = obj.bulbId ? obj.bulbId : '';
      state.filterSearch.excludeTags = obj.excludeTags ? obj.excludeTags : [];
      state.filterSearch.playlistRole = obj.playlistRole ? obj.playlistRole : [];
      state.filterSearch.playlistId = obj.playlistId ? obj.playlistId : '';
      let filters = '';

      if (
        obj.age.length > 0
        || obj.subject.length > 0
        || obj.keywords.length > 0
        || obj.excludeTags.length > 0
        || obj.standards != ''
        || obj.bulbId.length > 0
        || obj.playlistId.length > 0
      ) {
        /**
         * NOTE - You can NOT change the order of these filters because the backend logic is built on
         * these filters being in this order.  Just a heads up that if you are reading this you are in
         * for a headache.
        */
        //add age to filter string
        if(obj.age.length > 0) {
          let age = '';

          obj.age.forEach((item,index) => {
            state.tags.rawData.forEach(tag => {
              if(tag.type === 'age' && tag.value === item){
                age += `${tag.id}`
              }
            })
            if((index + 1 < obj.age.length)){
              age += ','
            }
          });

          filters += `age=${age};`
        } else {
          filters += 'age=;'
        }

        //add subject to filter string
        if(obj.subject.length > 0){
          let subject = '';

          obj.subject.forEach((item,index) => {
            state.tags.rawData.forEach(tag => {
              if(tag.type === 'subject' && tag.value === item){
                subject += `${tag.id}`
              }
            })
            if((index + 1 < obj.subject.length)){
              subject += ','
            }
          })

          filters += `subject=${subject};`
        } else {
          filters += 'subject=;'
        }

        if(obj.keywords.length > 0){
          filters += `keywords=${obj.keywords.join(',')};`
        } else {
          filters += 'keywords=;'
        }
        // bulb role filter settings
        if(obj.bulbRole.length > 0) {
          filters += `bulbRoles=${obj.bulbRole.join(',')};`
        } else {
          filters += 'bulbRoles=;'
        }
        if(obj.keywords.length > 0 && obj.tagExactMatch) {
          filters += `tagExactMatch=${obj.tagExactMatch};`
        } else {
          filters += `tagExactMatch=;`;
        }
        
        if(obj.bulbId.length > 0){
          filters += `bulbId=${obj.bulbId.join(',')};`
        } else {
          filters += 'bulbId=;'
        }
        // excludeTag filter
        if (obj.excludeTags.length > 0){
          filters += `excludeTags=${obj.excludeTags.join(',')};`
        } else {
          filters += 'excludeTags=;'
        }

        // playlist role filter settings
        if(obj.playlistRole.length > 0) {
          filters += `playlistRoles=${obj.playlistRole.join(',')};`
        } else {
          filters += 'playlistRoles=;'
        }

        if(obj.playlistId.length > 0){
          filters += `playlistId=${obj.playlistId.join(',')};`
        } else {
          filters += 'playlistId=;'
        }


      }
      filters += `contentType=${obj.contentType};`;

      state.filterString = filters;
      state.refreshData = true;
    },
    clearFilter(state, type) {
      if(type[0] === 'Creator'){
        state.filterSearch.creator_name = '';
        state.filterSearch.creator_id = '';
      } else if (type[0] === "Keywords/Tags"){
        let index = state.filterSearch.keywords.indexOf(type[1]);
        state.filterSearch.keywords.splice(index, 1);
      } else if (type[0] === "Exclude Tags"){
        let index = state.filterSearch.excludeTags.indexOf(type[1]);
        state.filterSearch.excludeTags.splice(index, 1);
      } else if (type[0] === "Bulb-Name") {
        let index = state.filterSearch.name.indexOf(type[1]);
        state.filterSearch.name.splice(index, 1);
      } else if (type[0] === "Creator-Name"){
        let index = state.filterSearch.creator.indexOf(type[1]);
        state.filterSearch.creator.splice(index, 1);
      } else if (type[0] === "Audience"){
        let index = state.filterSearch.age.indexOf(type[1]);
        state.filterSearch.age.splice(index, 1);
      } else if (type[0] === "Subject"){
        let index = state.filterSearch.subject.indexOf(type[1]);
        state.filterSearch.subject.splice(index, 1);
      } else if (type[0] === "Bulb-Role"){
        let index = state.filterSearch.bulbRole.indexOf(type[1]);
        state.filterSearch.bulbRole.splice(index, 1);
      } else if (type[0] === "Bulb-Id"){
        let index = state.filterSearch.bulbId.indexOf(type[1]);
        state.filterSearch.bulbId.splice(index, 1);
      } else if (type[0] === "Playlist-Role"){
        let index = state.filterSearch.playlistRole.indexOf(type[1]);
        state.filterSearch.playlistRole.splice(index, 1);
      } else if (type[0] === "Playlist-Id"){
        let index = state.filterSearch.playlistId.indexOf(type[1]);
        state.filterSearch.playlistId.splice(index, 1);
      } else if (type[0] === 'Classic'){
        state.filterSearch.legacy = false;
      } else if(type[0] === 'Youtube-Video'){
        state.filterSearch.youtube = ''
      } else if(type[0] === 'Organization'){
        state.filterSearch.all_district = true;
      }

      if (
        state.filterSearch.age.length === 0
        && state.filterSearch.subject.length === 0
        && state.filterSearch.keywords.length === 0
        && state.filterSearch.bulbRole.length === 0
        && state.filterSearch.bulbId.length === 0
        && state.filterSearch.playlistRole.length === 0
        && state.filterSearch.playlistId.length === 0 ) {
        state.filterString = '';
      } else {
        let filters = '';
        //add age to filter string
        if(state.filterSearch.age.length > 0){
          let age = '';

          state.filterSearch.age.forEach((item,index) => {
            state.tags.rawData.forEach(tag => {
              if(tag.type === 'age' && tag.value === item){
                age += `${tag.id}`
              }
            })
            if((index + 1 < state.filterSearch.age.length)){
              age += ','
            }
          })

          filters += `age=${age};`
        } else {
          filters += 'age=;'
        }

        //add subject to filter string
        if(state.filterSearch.subject.length > 0){
          let subject = '';

          state.filterSearch.subject.forEach((item,index) => {
            state.tags.rawData.forEach(tag => {
              if(tag.type === 'subject' && tag.value === item){
                subject += `${tag.id}`
              }
            })
            if((index + 1 < state.filterSearch.subject.length)){
              subject += ','
            }
          })

          filters += `subject=${subject};`
        } else {
          filters += 'subject=;'
        }

        if(state.filterSearch.keywords.length > 0){
          filters += `keywords=${state.filterSearch.keywords.join(',')};`
        } else {
          filters += 'keywords=;'
        }

        if(state.filterSearch.excludeTags.length > 0){
          filters += `excludeTags=${state.filterSearch.excludeTags.join(',')};`
        } else {
          filters += 'excludeTags=;'
        }
        
        // bulb role filter settings
        if(state.filterSearch.bulbRole.length > 0) {
          filters += `bulbRoles=${state.filterSearch.bulbRole.join(',')};`
        } else {
          filters += 'bulbRoles=;'
        }

        // retain the exact match filter option if applied:
        if(state.filterSearch.tagExactMatch) {
          filters += `tagExactMatch=${obj.tagExactMatch};`
        } else {
          filters += 'tagExactMatch=;'
        }

        if(state.filterSearch.bulbId.length > 0) {
          filters += `bulbId=${state.filterSearch.bulbId.join(',')};`
        } else {
          filters += 'bulbId=;'
        }

        // bulb role filter settings
        if(state.filterSearch.playlistRole.length > 0) {
          filters += `playlistRoles=${state.filterSearch.playlistRole.join(',')};`
        } else {
          filters += 'playlistRoles=;'
        }

        if(state.filterSearch.playlistId.length > 0) {
          filters += `playlistId=${state.filterSearch.playlistId.join(',')};`
        } else {
          filters += 'playlistId=;'
        }

        state.filterString = filters;
      }
      state.refreshData = true;
    },
    setTags(state, data){
      let age = [];
      let subject = [];
      let keywords = [];
      let proquest = [];

      data.forEach(item => {
        if(item.type === 'age') age.push(item.value);
        if (item.type === 'subject') subject.push(item.value);
        if (item.type === 'proquest') proquest.push(item.value);
        if(item.id === 1){
          item.value.forEach(word => {
            keywords.push(word.text)
          })
        }
      })
      
      state.tags.age = age;
      state.tags.subject = subject.sort();
      state.tags.proquest = proquest.sort();
      state.tags.keywords = keywords;
      state.tags.rawData = data;
    },
    setKeywordTag(state, data){
      state.tags.keywords = data.keywords;
    },
    clearAllFilters(state){
      state.filterSearch = {
        contentType: 'Bulbs',
        creator_id: '',
        creator_name: '',
        age: [],
        subject: [],
        keywords: [],
        name: [],
        creator: [],
        bulbRole:[],
        youtube: '',
        bulbId:'',
        all_district: true,
        legacy: false,
        tagExactMath: false,
        excludeTags: [],
        playlistRole: [],
        playlistId: [],
      }
      state.filterString = '';
      state.refreshData = true;
      state.filtersInteraction = {
        selectedStatus: 'All',
        status: ['All', 'Completed', 'In Progress', 'Not Started'],
        isFiltered: false,
        filteredBy: ''
      }
    },
    clearAllFiltersNoReload(state){
      state.filterSearch = {
        ready: false,
        contentType: 'Bulbs',
        creator_id: '',
        creator_name: '',
        age: [],
        subject: [],
        keywords: [],
        name: [],
        creator: [],
        bulbRole: [],
        youtube: '',
        bulbId:'',
        all_district: true,
        legacy: false,
        tagExactMatch: false,
        excludeTags: [],
        playlistRole: [],
        playlistId: [],
      }
      state.queryParamsInstructors.sort = '';
      state.filterString = '';
      state.filtersInteraction = {
        selectedStatus: 'All',
        status: ['All', 'Completed', 'In Progress', 'Not Started'],
        isFiltered: false,
        filteredBy: ''
      }
    },
    updateScore(state, data){
      let interactions = [...state.interactions.data];
      interactions.map(item => {
        if(item.bulbattempt_id === data.bulb_attempt_id){
          let score = `${((data.new_points_earned / item.points_available) * 100).toFixed(0)}%`
          item.score = score;
        }
      })

      state.interactions.data = interactions;
      //reset the interaction viewer
      state.reloadInteractionViewerId = null;
    },
    updateShowPointsMode(state, value) {
      state.showPointsMode = value;
    },
    reloadInteractionViewerIdToggle(state, id){
      state.reloadInteractionViewerId = id;
    },
    setEditLMBRubric(state, boolean){
      state.editLMBRubric = boolean;
    },
    setGroupData(state, data) {
      state.groups = data;
    },
    setFolderBulb(state, data){
      state.foldersBulb.folders = data.folders;
      state.foldersBulb.folders_bulb = data.bulbfolders;
    },
    setBulbAnalytics(state, data) {
      state.bulbAnalytics = data;
      // Loops through data and adds to datasets in graph for Bulb Summary
      for (let i = 0; i < data.bulbAnalyticsSummary.length; i += 1) {
        let timeStamp = moment().startOf('day').seconds(data.bulbAnalyticsSummary[i].time_stamp).format('H:mm:ss');
        state.bulbAnalyticsSummaryChart.labels.push([`I${i+1}`, timeStamp]); // - Code to display Interaction # and Timestamp
        // state.bulbAnalyticsSummaryChart.labels.push(timeStamp); // Just timestamp
        // state.bulbAnalyticsSummaryChart.labels.push('format_list_bulleted'); - Code for adding icon instead of timestamp
        state.bulbAnalyticsSummaryChart.datasets[0].icons.push('format_list_bulleted');
        state.bulbAnalyticsSummaryChart.datasets[0].data.push(parseInt(data.bulbAnalyticsSummary[i].correct));
        state.bulbAnalyticsSummaryChart.datasets[1].data.push(parseInt(data.bulbAnalyticsSummary[i].incorrect));
        state.bulbAnalyticsSummaryChart.datasets[2].data.push(parseInt(data.bulbAnalyticsSummary[i].ungraded));
      }
      // Bulb Average Score - Set data in average score chart
      const totalResponses = data.bulbAverageScore[0].percent_100 + data.bulbAverageScore[0].percent_75_up + data.bulbAverageScore[0].percent_50_75 + data.bulbAverageScore[0].percent_50_down;
      state.bulbAverageScoreChart.datasets[0].data.push(data.bulbAverageScore[0].percent_100, data.bulbAverageScore[0].percent_75_up, data.bulbAverageScore[0].percent_50_75, data.bulbAverageScore[0].percent_50_down);
      // Bulb Complete - Set data for completed chart
      state.bulbCompleteChart.datasets[0].data.push(data.bulbCompleteAnalytics[0].completed, data.bulbCompleteAnalytics[0].started, data.bulbCompleteAnalytics[0].unstarted);
      // Forces charts to update
      state.summaryChartKey += 1;
      state.averageChartKey += 1;
      state.completeChartKey += 1;
    },
    // Sets loading on adding co-owner combobox
    setSearchingForEmailMatch (state, value) {
      state.searchingForEmailMatch = value;
    },
    setAddRemoveBulbFolder(state, obj){
      if(obj.add){
        //if add, add to obj
        state.foldersBulb.folders_bulb[obj.data.folderId] = 'added';
      } else {
        //if remove- delete from obj
        delete state.foldersBulb.folders_bulb[obj.data.folderId];
      }
    },
    setSectionHasPlaylist(state, value) {
      state.sectionHasPlaylist = value;
    },
    instructorBatchLoading(state, value) {
      state.instructorBatchLoading = value;
    },
}

const actions = {
  async addSessionStartTime(context, data) {
    return await axios.put(`${context.rootState.nodeApiPrefix}/instructor/session-start-time/`,
      {
        bulbId: data.bulbId,
        sectionId: data.sectionId,
        sessionStartTime: data.sessionStartTime,
      },
      {
        headers: {
          'Authorization': `Bearer ${context.rootState.instructorData.token}`
        }
      })
  },
  async createNewPlaylist(context) {
    try {
      state.dynamicDataLoaded = false;
      /*
      * The microservice and the backend have the same name /playlist - 
      * to get around CORS issues and the server trying to serve build files the option param apiVersion
      * is required to correctly hit the backend route and not attempt to get build files.
      */
      const { data: playlist } = await axios.post(`${context.rootState.nodeApiPrefix}/1.0/playlist`, {},
        {
          headers: {
            'Authorization': `Bearer ${context.rootState.instructorData.token}`,
          }
        });
      state.dynamicDataLoaded = true;
      window.open(`${context.rootState.nodeApiPrefix}/course/${hashids.encode(playlist.id)}?token=${context.rootState.instructorData.token}${context.rootGetters.LTIlaunch ? '&lms_launch=true' : ''}`, '_blank');
      context.commit('refreshData');
    } catch (e) {
      state.dynamicDataLoaded = true;
      context.commit('triggerSnackbar', { text: "Trouble creating Playlist.", color: 'red', timeout: 5000 }, { root: true });
      throw (e);
    }
  },
  getGoogleClassroomData(context, data) {
    return axios.get(`${context.rootState.nodeApiPrefix}/google-classroom/data?state=${data.state}&code=${data.code}&redirectURL=${data.redirectURL}&switchAccount=${data.switchAccount}`, {
      headers: {
        'Authorization': `Bearer ${data.token}`,
      }
    });
  },
  createGoogleClassroomAssignment(context, data) {
    return axios.post(`${context.rootState.nodeApiPrefix}/google-classroom/assignment`,
      {
        contentId: data.contentId,
        courseWork: data.courseWork,
        sectionId: data.sectionId,
        contentType: data.contentType,
      }, {
      headers: {
        'Authorization': `Bearer ${data.token}`,
      }
    });
  },
  importGoogleClassroomCourse(context, data) {
    return axios.post(`${context.rootState.nodeApiPrefix}/google-classroom/courseImport`, { courseId: data.courseId }, {
      headers: {
        'Authorization': `Bearer ${data.token}`,
      }
    });
  },
  exportGoogleGrades: async (context, data) => {
    try {
      context.state.instructorAjaxing = true;
      await axios.post(`${context.rootState.nodeApiPrefix}/google-classroom/gradeExport`, data, {
        headers: {
          'Authorization': `Bearer ${context.rootState.instructorData.token}`,
        }
      });
      context.commit('triggerSnackbar',
        {
          text: "Grades exported.",
          color: 'success',
          timeout: 6000
        }, { root: true });
    } catch (e) {
      context.commit('triggerSnackbar',
        {
          text: "Error exporting grades.",
          color: 'warning',
          timeout: 6000
        }, { root: true });
    } finally {
      context.state.instructorAjaxing = false;
    }
  },
  updateUrl: ({ state, rootState }) => {
    // updates the url on changes to table including activeView and all query params
    router.push({
      name: 'instructor',
      params: { activeView: rootState.activeView, secondaryView: state.activeViewInstructor },
      query: {
        page: state.queryParamsInstructors.page,
        per_page: state.queryParamsInstructors.per_page,
        search: state.queryParamsInstructors.search,
        sort: state.queryParamsInstructors.sort,
        section_id: state.queryParamsInstructors.section_id,
        bulb_id: state.queryParamsInstructors.bulb_id,
        interaction_id: state.queryParamsInstructors.interaction_id,
        interaction_type: state.queryParamsInstructors.interaction_type,
        student_id: state.queryParamsInstructors.student_id,
        folder_id: state.queryParamsInstructors.folder_id,
        subfolder_id: state.queryParamsInstructors.subfolder_id,
        lms_class: state.queryParamsInstructors.lms_class,
        lms_launch: rootState.LTIlaunch,
        lmb_bulb: state.queryParamsInstructors.lmb_bulb,
        lmb_section: state.queryParamsInstructors.lmb_section,
        breadcrumbs: encodeURI(JSON.stringify(rootState.breadcrumbs)),
        gradebook: encodeURI(JSON.stringify(state.gradebookBreadcrumbs)),
        embed: state.queryParamsInstructors.embed,
        isProquest: state.queryParamsInstructors.isProquest,
        playlistGradebook: state.queryParamsInstructors.playlistGradebook,
      }
    });

    //set array to blank array, find data from storejs if available
    let array = []
    if (storejs.get('url')) {
      array = storejs.get('url');
    }
    //push state to storejs for back button functionality
    array.push({
      path: router.history.current.fullPath, data: {
        name: 'instructor',
        params: { activeView: rootState.activeView, secondaryView: state.activeViewInstructor },
        query: {
          page: state.queryParamsInstructors.page,
          per_page: state.queryParamsInstructors.per_page,
          search: state.queryParamsInstructors.search,
          sort: state.queryParamsInstructors.sort,
          section_id: state.queryParamsInstructors.section_id,
          bulb_id: state.queryParamsInstructors.bulb_id,
          interaction_id: state.queryParamsInstructors.interaction_id,
          interaction_type: state.queryParamsInstructors.interaction_type,
          student_id: state.queryParamsInstructors.student_id,
          folder_id: state.queryParamsInstructors.folder_id,
          subfolder_id: state.queryParamsInstructors.subfolder_id,
          lms_class: state.queryParamsInstructors.lms_class,
          lms_launch: rootState.LTIlaunch,
          lmb_bulb: state.queryParamsInstructors.lmb_bulb,
          lmb_section: state.queryParamsInstructors.lmb_section,
          breadcrumbs: encodeURI(JSON.stringify(rootState.breadcrumbs)),
          gradebook: encodeURI(JSON.stringify(state.gradebookBreadcrumbs)),
          isProquest: state.queryParamsInstructors.isProquest,
        }
      }
    })
    storejs.set('url', array);
  },
  getCommentData: async ({ rootState }, interactionData) => {
    return axios.get(`${rootState.nodeApiPrefix}/instructor/feedback/${interactionData.interactionAttemptId}?sectionId=${interactionData.sectionId}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
  },
  removeCommentData: async ({ rootState }, interactionData) => {
    const { interactionAttemptId, teacherId, sectionId } = interactionData;
    return axios.put(`${rootState.nodeApiPrefix}/instructor/feedback/`, {
      interactionAttemptId,
      sectionId,
    }, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
  },
  getClasses: async ({ state, commit, rootState }) => {
    //data call for classes used throughout the instructor view
    //get class data
    await commit('setClasses', {
      archived: false,
      pagination: {
        total: 0,
      },
      data: [],
    });
    axios.get(`${rootState.nodeApiPrefix}/instructor/classes?page=all&archived=false`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        //if success, set class data
        if (res.data.msg === "success") {
          commit('setClasses', res.data);
          // If this is for playlistMonitoring - turn off loader after classes are set
          if (state.playlistModalLoading) state.playlistModalLoading = false;
        }
      }).catch(err => {
        //if error, log error, trigger snackbar, and turn off ajaxing
        console.error(err);
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', { text: "Classes data cannot load at this time", color: 'red', timeout: 6000 }, { root: true });
      });
  },
  getLearners: async ({ state, commit, rootState }, sectionId) => {
    // load a section's students into vuex, primarily for loading students for group management with out loading the whole table
    try {
      state.instructorAjaxing = true;
      const res = await axios.get(`${rootState.nodeApiPrefix}/instructor/learners?section_id=${sectionId}&page=1&per_page=1000&`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      state.students.pagination = {
        total: res.data.data.total,
      };
      state.students.data = res.data.data.data;
    } catch (err) {
      console.log(err);
      commit('triggerSnackbar', { text: 'Unable to load unassigned group students', color: 'red', timeout: 6000 }, { root: true });
    } finally {
      state.instructorAjaxing = false;
    }
  },
  //Data call for Table Component from the side nav
  getTableData: async ({ commit, dispatch, state, rootState }) => {
    //set route to get table data
    let route, endpoint, playlistDataExists;
    let bulb_id = state.queryParamsInstructors.bulb_id;
    let section_id = state.queryParamsInstructors.section_id;
    const lti13Launch = state?.queryParamsInstructors?.lti13Launch;
    commit('setSectionHasPlaylist', false);
    //data call for table component based on activeView
    if (!state.instructorAjaxing) {
      switch (state.activeViewInstructor) {
        case 'Gradebook':
          route = 'gradebook'
          endpoint = `classes/${section_id}/bulbattempts`
          break;
        case 'Interactions':
          route = 'interactions'
          endpoint = `classes/${section_id}/bulbs/${bulb_id}/interactionattempts`
          break;
        case 'Student-Bulb-Attempts':
        case 'Bulb-Attempts':
          route = 'bulbattempts'
          endpoint = `classes/${section_id}/learners/${state.queryParamsInstructors.student_id}/bulbattempts`
          break;
        case 'Single-Interaction':
          route = 'singleinteraction'
          endpoint = `classes/${section_id}/interactions/${state.queryParamsInstructors.interaction_id}`
          break;
        case 'Student-Interaction':
          route = 'studentinteraction'
          endpoint = `classes/${section_id}/bulbs/${bulb_id}/learners/${state.queryParamsInstructors.student_id}/interactionattempts`
          break;
        case 'My-Bulbs':
        case 'Bulbs':
          route = 'bulbs'
          endpoint = route
          break;
        case 'Classes':
          route = 'classes'
          endpoint = route
          break;
        case 'Learners':
          route = 'students'
          endpoint = `learners`
          break;
        case 'Folders':
          route = 'folders'
          endpoint = route
          break;
        case 'Folder':
          route = 'singlefolder'
          endpoint = `folders/${state.queryParamsInstructors.folder_id}`
          break;
        case 'Subfolder':
          route = 'subfolder'
          endpoint = `folders/${state.queryParamsInstructors.folder_id}/subfolders/${state.queryParamsInstructors.subfolder_id}`
          break;
        case 'My-Videos':
          route = 'videos'
          endpoint = route
          break;
        case 'Learner-Made-Bulb':
          route = 'lmb'
          endpoint = `classes/${section_id}/learnermadebulbs/${bulb_id}`
          break;
        case 'Learner-Made-Bulb-Monitor':
          route = 'lmbmonitor'
          endpoint = route
          break;
        case 'Peer-Review':
          route = 'peerreview'
          endpoint = `classes/${section_id}/peerreviewbulbs/${bulb_id}`
          break;
        case 'Playlists':
          route = 'playlists';
          endpoint = 'playlists';
          break;
        default:
          console.log("Error: Please add route to instructor's getTableData switch function", route, state.activeViewInstructor)
          break;
      }

      //set ajaxing and data loading booleans
      state.instructorAjaxing = true;
      state.dynamicDataLoaded = false;

      let timestamp = moment();

      if (route === 'lmbmonitor') {
        bulb_id = state.queryParamsInstructors.lmb_bulb;
        section_id = state.queryParamsInstructors.lmb_section;
      }

      //set archived for classes
      let archived = false;
      if (route === 'classes') {
        archived = state.classes.archived;
      }
        
      // If accessing a specific Class or Class Gradebook, grab all Playlists to filter Gradebook table
      if (
        (
          route === 'gradebook'
          && state.activeViewInstructor === 'Gradebook'
        )
        || (
          route === 'bulbs'
          && state.activeViewInstructor === 'Bulbs'
        )
      ) {
        const {
          nodeApiPrefix,
          instructorData: {
            token: instructorToken,
          }
        } = rootState;
        bulb_id = '';
        const playlists = await axios.get(
          PLAYPOSIT_API_ENDPOINTS.instructorPlaylistDashData({
            nodeApiPrefix,
            sectionId: section_id,
            lti13Launch,
          }),
          {
            headers: {
              'Authorization': `Bearer ${instructorToken}`
            }
          }
        );
          // Set playlist Data & Access
          playlistDataExists = _.find(playlists.data, { id: parseInt(_.get(router, 'currentRoute.query.playlistGradebook', 0), 10) });
          if (playlists.data.length > 0) commit('setSectionHasPlaylist', true);
          if (
            _.get(router, 'currentRoute.query.playlistGradebook', false)
            && _.get(router, 'currentRoute.query.playlistGradebook', false) !== 'All Bulbs'
            && !playlistDataExists
          ) { // playlistGradebook param set but no playlistSection - non-launched LTI playlist
            commit('setQueryParams', { playlistGradebook: null });
            dispatch('updateUrl');
            commit('refreshData');
          }
          // If accessing gradebook - add 'All Bulbs' to array for filtering
          if (route === 'gradebook' && state.activeViewInstructor === 'Gradebook') playlists.data.unshift('All Bulbs');
          commit('setSectionPlaylists', playlists.data);
      }
        
      // applying bulbanalytics filters for endpoints
      let selectedStatus = state.filtersInteraction.selectedStatus !== 'All' ? state.filtersInteraction.selectedStatus : '';

      //get table data based on route
      if (
        _.get(router, 'currentRoute.query.playlistGradebook', false)
        && _.get(router, 'currentRoute.query.playlistGradebook', false) !== 'All Bulbs'
        && state.activeViewInstructor === 'Gradebook'
        && playlistDataExists
      ) {
        dispatch('getPlaylistGradebookData');
      } else {
        axios.get(
          PLAYPOSIT_API_ENDPOINTS.instructorDash({
            rootState,
            state,
            endpoint,
            route,
            bulb_id,
            section_id,
            selectedStatus,
            archived,
            timestamp,
          }),
          {
            headers: {
              'Authorization': `Bearer ${rootState.instructorData.token}`,
            },
          }
        ).then(res => {
          //if success, set table data and turn off ajaxing
          if (res.data.msg === "success") {
            if (
              route === 'interactions'
              && state.embedded
            ) {
              rootState.breadcrumbs = [
                {
                  text: (
                    res.data.data.breadcrumbs
                    && res.data.data.breadcrumbs.sectionName
                  ) || 'Class', payload: ''
                },
                {
                  text: (
                    res.data.data.breadcrumbs
                    && res.data.data.breadcrumbs.bulbName
                  ) || 'Bulb', payload: ''
                }
              ];
            }
            commit('setTableData', {
              data: res.data.data,
              route: route,
              tz: rootState.instructorData.timezone,
              ...(rootState?.LTIdata && { ltiData: rootState?.LTIdata }),
            });
          }
          state.instructorAjaxing = false;
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: `${state.activeViewInstructor} data cannot load at this time`, color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
          state.dynamicDataLoaded = true;
        });
      }
    }
  },
  getFolderContents: ({ commit, state, rootState }, obj) => {
    return new Promise((resolve, reject) => {
      let route = obj.route;
      let endpoint = obj.endpoint;
      axios.get(
        PLAYPOSIT_API_ENDPOINTS.instructorDash({
          rootState,
          state,
          endpoint,
          route,
        }),
        {
          headers: {
            'Authorization': `Bearer ${rootState.instructorData.token}`,
          },
        }
      ).then(res => {
        if (res.data.msg === "success") {
          resolve(res.data.data.data);
        } else {
          reject(new Error('Failed to fetch data'));
        }
      }).catch(err => { 
        reject(err);
      });
    });
  },
  getNestedBulbsInSelectedFolders: async (context, data) => {
    let bulbs = [];
    for (const item of data) {
      if (item.isFolder === 0) {
        bulbs.push(item);
      } else {
        const subFolder = await context.dispatch('getFolderContents', {
          route: 'singlefolder',
          endpoint: `folders/${item.id}`,
        });
        for (const subItem of subFolder) {
          if (subItem.isFolder === 0) {
            bulbs.push(subItem);
          } else {
            const bulbsInFolder = await context.dispatch('getFolderContents', {
              route: 'singlefolder',
              endpoint: `folders/${subItem.id}`,
            });
            bulbs = bulbs.concat(bulbsInFolder);
          }
        }
      }
    }
    bulbs = bulbs.filter((item, index, self) => {
      return index === self.findIndex(otherItem => otherItem.id === item.id);
    });
    return bulbs;
  },
  getPlaylistAverageScore: async (context, playlistId) => {
    try {
      const playlistAverage = await axios.get(`${context.rootState.nodeApiPrefix}/instructor/section/${context.state.queryParamsInstructors.section_id}/playlist/${playlistId}/average`,
        {
          headers: { 'Authorization': `Bearer ${context.rootState.instructorData.token}` },
        });
      context.state.playlistAverage = playlistAverage.data;
    } catch (e) {
      dataLayer.axiosLog(e);
    }
  },
  getPlaylistGradebookData: async ({ commit, state, rootState, dispatch }, selectedClass) => {
    const selectedStatus = state.filtersInteraction.selectedStatus !== 'All' ? state.filtersInteraction.selectedStatus : '';
    try {
      state.instructorAjaxing = true;
      state.dynamicDataLoaded = false;
      dispatch('getPlaylistAverageScore', router.currentRoute.query.playlistGradebook);
      const { data: response } = await axios.get(`${rootState.nodeApiPrefix}/instructor/classes/${state.queryParamsInstructors.section_id}/playlist/${selectedClass ? selectedClass : router.currentRoute.query.playlistGradebook}?page=${state.queryParamsInstructors.page}&per_page=${state.queryParamsInstructors.per_page}&search=${state.queryParamsInstructors.search}&sort=${state.queryParamsInstructors.sort}&timezone=${rootState.instructorData.timezone}&filter_status=${selectedStatus}`,
        {
          headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` }
        }
      );
      if (response.msg === "success") {
        commit('setTableData', { data: response.playlistGradebook.searchResponse, route: 'gradebook', tz: rootState.instructorData.timezone });
        state.instructorAjaxing = false;
      }
    } catch (e) {
      dataLayer.axiosLog(e);
      commit('triggerSnackbar', { text: `${state.activeViewInstructor} data cannot load at this time`, color: 'red', timeout: 6000 }, { root: true });
      state.instructorAjaxing = false;
      state.dynamicDataLoaded = true;
    }
  },
  getPlaylistMonitorData: async ({ commit, state, dispatch, rootState }, playlistId) => {
    try {
      state.instructorAjaxing = true;
      state.playlistModalLoading = true;
      await dispatch('getClasses');
      const { data: assignedDates } = await axios.get(`${rootState.nodeApiPrefix}/instructor/playlist/${playlistId}/assignedDates`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      commit('setPlaylistAssignedDates', assignedDates);
    } catch (e) {
      commit('triggerSnackbar', { text: `Playlist monitor data cannot load at this time`, color: 'red', timeout: 6000 }, { root: true });
    } finally {
      state.instructorAjaxing = false;
    }
  },
  getBulbActivity: async (context, bulbId) => {
    try {
      const { data: bulbActivity } = await axios.get(`${context.rootState.nodeApiPrefix}/bulb-audit-log/${bulbId}`, { headers: { 'Authorization': `Bearer ${context.rootState.instructorData.token}` } });
      return bulbActivity;
    } catch (e) {
      context.commit('triggerSnackbar', {
        text: `Error getting bulb activity.`,
        color: 'red',
        timeout: 6000
      }, { root: true });
    }
  },
  deletePlaylist: async (context, playlistId) => {
    try {
      state.playlistModalLoading = true;
      state.instructorAjaxing = true;
      context.rootState.admin.adminAjaxing = true;
      await axios.delete(`${context.rootState.nodeApiPrefix}/instructor/playlist/${playlistId}`, { headers: { 'Authorization': `Bearer ${context.rootState.instructorData.token}` } });
      context.commit('setDashModal', (null), { root: true });
    } catch (e) {
      context.commit('triggerSnackbar', { text: 'Error deleting playlist.', color: 'red', timeout: 6000 }, { root: true });
    } finally {
      context.commit('refreshData');
      state.playlistModalLoading = false;
      state.instructorAjaxing = false;
      context.rootState.admin.adminAjaxing = false;
    }
  },
  assignPlaylistSection: async ({ commit, state, rootState }, obj) => {
    try {
      if (!state.instructorAjaxing) {
        state.instructorAjaxing = true;
        state.playlistModalLoading = true;
        if (obj.assigned_date) {
          const dateString = moment(obj['assigned_date']).format("YYYY-MM-DD HH:mm:ss").toString();
          //format dateString to instructor timezone, then utc to save in db
          obj.assigned_date = moment.tz(dateString, rootState.instructorData.timezone).utc().format();
        }
        await axios.post(`${rootState.nodeApiPrefix}/instructor/playlist/${obj.playlistId}/section/${obj.sectionId}`,
          obj,
          {
            headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` }
          });
      }
    } catch (e) {
      context.commit('triggerSnackbar', { text: 'Error assigning playlist.', color: 'red', timeout: 6000 }, { root: true });
    } finally {
      state.playlistModalLoading = false;
      state.instructorAjaxing = false;
    }
  },
  unassignPlaylistSection: async ({ commit, state, rootState }, obj) => {
    try {
      if (!state.instructorAjaxing) {
        state.instructorAjaxing = true;
        state.playlistModalLoading = true;
        await axios.delete(`${rootState.nodeApiPrefix}/instructor/playlist/${obj.playlistId}/section/${obj.sectionId}`,
          {
            headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` }
          }
        );
      }
    } catch (e) {
      context.commit('triggerSnackbar', { text: 'Error unassigning playlist.', color: 'red', timeout: 6000 }, { root: true });
    } finally {
      state.playlistModalLoading = false;
      state.instructorAjaxing = false;
    }
  },
  resetPlaylistAttempts: async ({ commit, state, rootState }, obj) => {
    try {
      if (!state.instructorAjaxing) {
        state.instructorAjaxing = true;
        state.playlistModalLoading = true;
        await axios.delete(`${rootState.nodeApiPrefix}/instructor/playlist/attempts`,
          {
            data: obj,
            headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` },
          }
        );
      }
    } catch (e) {
      context.commit('triggerSnackbar', { text: 'Error resetting playlist attempt(s).', color: 'red', timeout: 5000 }, { root: true });
    } finally {
      commit('setDashModal', (null), { root: true });
      state.refreshData = true;
      state.playlistModalLoading = false;
      state.instructorAjaxing = false;
    }
  },
  //routes for premade, my community and legacy premade table data with extra filter options
  getPremadeTableData: ({ commit, state, rootState }, obj) => {
    //set route to get table data
    let route;
    let routePath;
    switch (state.activeViewInstructor) {

      case 'Premade-Bulbs':
        routePath = state.premadeFilterContentType === 'Bulbs' ? 'premadebulbs' : 'premade-playlists';
        route = 'premade';
        break;
      case 'Premade-Bulbs-Legacy':
        route = 'premade';
        break;
      case 'My-Community':
        routePath = state.premadeFilterContentType === 'Bulbs' ? 'premadebulbs' : 'premade-playlists';
        route = 'community';
        break;
      case 'My-Community-Legacy':
        route = 'community';
        break;
      default:
        console.log("Error: Please add route to instructor's getPremadeTableData switch function");
        break;
    }

    let teacher_id = '';
    if (obj.teacher_id) {
      teacher_id = obj.teacher_id;
      state.filterSearch.creator_id = obj.teacher_id;
      state.filterSearch.creator_name = obj.teacher_name;
    } else {
      teacher_id = state.filterSearch.creator_id;
    }

    //data call for table component based on activeView
    if (!state.instructorAjaxing) {
      //set ajaxing and data loading booleans
      state.instructorAjaxing = true;
      state.dynamicDataLoaded = false;

      //set variables to search based on filters
      let keywords = (state.filterSearch.keywords.length > 0) ? state.filterSearch.keywords.join(',') : '';
      const excludeTags = (state.filterSearch.excludeTags.length > 0) ? state.filterSearch.excludeTags.join(',') : '';
      let name = (state.filterSearch.name.length > 0) ? state.filterSearch.name.join(',') : '';
      let creator = (state.filterSearch.creator.length > 0) ? state.filterSearch.creator.join(',') : '';

      let age = '';
      if (state.filterSearch.age.length > 0) {
        state.filterSearch.age.forEach((item, index) => {
          state.tags.rawData.forEach(tag => {
            if (tag.type === 'age' && tag.value === item) {
              age += `${tag.id}`
            }
          })
          if ((index + 1 < state.filterSearch.age.length)) {
            age += ','
          }
        })
      }

      let subject = '';
      if (state.filterSearch.subject.length > 0) {
        state.filterSearch.subject.forEach((item, index) => {
          state.tags.rawData.forEach(tag => {
            if (tag.type === 'subject' && tag.value === item) {
              subject += `${tag.id}`
            }
          })
          if ((index + 1 < state.filterSearch.subject.length)) {
            subject += ','
          }
        })
      }
        let districtSchoolIds = '';
        if (
          (
            state.activeViewInstructor === 'My-Community'
            || state.activeViewInstructor === 'My-Community-Legacy'
          )
          && state.filterSearch.all_district
        ) districtSchoolIds = rootState.school.district_schools;

        // Get table data based on route
        const shouldUseCacheUrl = ![
          'api-test-16.playposit.com',
          'api-dev.playposit.com',
          'api-stage.playposit.com',
          '127.0.0.1',
          'localhost',
        ].includes(window.location.hostname);
        const cacheRoute = shouldUseCacheUrl ? 'https://cache.playposit.com' : rootState.nodeApiPrefix;
        axios.get(`
        ${cacheRoute}/instructor/${routePath}?page=${state.queryParamsInstructors.page}&per_page=${state.queryParamsInstructors.per_page}&sort=${state.queryParamsInstructors.sort}&school_id=${rootState.school.id}&districtSchoolIds=${districtSchoolIds}&teacher_search=${teacher_id}&age=${age}&subject=${subject}&name=${name}&creator=${creator}&legacy=${state.filterSearch.legacy}&keywords=${keywords}&tag_exact_match=${state.filterSearch.tagExactMatch}&video=${state.filterSearch.youtube}&all_district=${state.filterSearch.all_district}&type=${route}&hostReferrer=${window.location.hostname}&excludeTags=${excludeTags}`, {
          headers: {
              'Authorization':`Bearer ${rootState.instructorData.token}`,
            }
          }).then((res) => {
          // If success, set table data and turn off ajaxing:
          if (res.data.msg === "success") {
            commit('setTableData', {data: res.data.data, route: route, tz:rootState.instructorData.timezone});
          }
          state.instructorAjaxing = false;
        }).catch(err => {
          // If error, log error, trigger snackbar and turn off ajaxing:
          console.error(err);
          dataLayer.errorLog(err.response);
          commit(
            'triggerSnackbar', {
              text:`${state.activeViewInstructor} data cannot load at this time`,
              color: 'red',
              timeout: 6000
            } , {
              root:true
            });
          state.instructorAjaxing = false;
          state.dynamicDataLoaded = true;
        });
    }
  },

  //functions for bulb settings
  getTags: async ({ commit, state, rootState }, obj) => {
    try {
      const isSearch = (obj && obj.isSearch) ? true : false;
      let searchUrl = '';
      if (isSearch) {
        commit('setSearchingForTags', true, { root: true });
        searchUrl = `?searchString=${obj.searchString}&isSearch=${isSearch}${obj.isPlaylist ? '&isPlaylist=1' : ''}`;
      }
      const res = await axios.get(`${rootState.nodeApiPrefix}/instructor/tags${searchUrl}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      //if success, set table data and turn off ajaxing
      if (res && res.data && res.data.msg === "success") commit('setTags', res.data.data);
      commit('setSearchingForTags', false, { root: true });
    } catch (err) {
      commit('setSearchingForTags', false, { root: true });
      //if error, log error, trigger snackbar and turn off ajaxing
      console.error(err);
      dataLayer.errorLog(err.response);
      commit('triggerSnackbar', { text: `Getting tags not working at this time.`, color: 'red', timeout: 6000 }, { root: true });
    }
  },
  updateInstructorBulbSettings: async ({ commit, state, rootState }, bulb) => {
    try {
      state.instructorBatchLoading = true;
      const bulbData = await axios.post(`${rootState.nodeApiPrefix}/instructor/updatebulbsettings`, bulb, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      const tagData = await axios.get(`${rootState.nodeApiPrefix}/instructor/bulbs/${bulb.bulb_id}/tags`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      return { bulbData, tagData };
    } catch (err) {
      //if error, log error, trigger snackbar and turn off ajaxing
      dataLayer.errorLog(err.response);
      commit('triggerSnackbar', { text: "Adding tags to bulb did not work at this time.", color: 'red', timeout: 6000 }, { root: true });
    } finally {
      state.instructorBatchLoading = false;
      commit('refreshData');
    }
  },

  //creation/edit actions

  createClass: ({ commit, state, rootState }, array) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;

      //save class name and color
      let data = { name: array[0].trim(), default_color: array[1].trim() }
      //post new class data
      axios.post(`${rootState.nodeApiPrefix}/instructor/classes`, data, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh and turn off ajaxing
          if (res.data.msg === "success") {
            state.refreshData = true;
            state.instructorAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Creating class did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
        });
    }
  },
  editClass: ({ commit, state, rootState }, array) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;

      //trim color or set to null if the default color
      let color;
      if (array[1] === '#737373') {
        color = null;
      } else {
        color = array[1].trim();
      }

      //set name, color, and class id to data
      let data = { name: array[0].trim(), default_color: color }
      //post edited class data
      axios.post(`${rootState.nodeApiPrefix}/instructor/classes/${array[2]}`, data, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh and turn off ajaxing
          if (res.data.msg === "success") {
            state.refreshData = true;
            state.instructorAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Editing your class did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
        });
    }
  },
  createFolder: ({ commit, state, rootState }, obj) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;
      //post new class data
      axios.post(`${rootState.nodeApiPrefix}/instructor/folders`, obj, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh and turn off ajaxing
          if (res.data.msg === "success") {
            state.refreshData = true;
            state.instructorAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Creating folder did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
        });
    }
  },
  editFolder: ({ commit, state, rootState }, obj) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;

      //post new class data
      axios.post(`${rootState.nodeApiPrefix}/instructor/folders/${obj.id}`, obj, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh and turn off ajaxing
          if (res.data.msg === "success") {
            state.refreshData = true;
            state.instructorAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Editing folder did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
        });
    }
  },
  deleteFolder: ({ commit, state, rootState }, obj) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;

      //post new class data
      axios.delete(`${rootState.nodeApiPrefix}/instructor/folders/${obj.folder_id}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh and turn off ajaxing
          if (res.data.msg === "success") {
            state.refreshData = true;
            state.instructorAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Deleting folder did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
        });
    }
  },
  getFolders: ({ commit, state, rootState }, id) => {

    commit('setPopoverDataLoading', true, { root: true });
    let timestamp = moment();
    //get assigned dates for bulb for all classes
    axios.get(`${rootState.nodeApiPrefix}/instructor/foldersbulb?bulb_id=${id}&timestamp=${timestamp}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        //if success, sets assigned date data
        if (res.data.msg === "success") {
          commit('setFolderBulb', res.data.data);
          commit('setPopoverDataLoading', false, { root: true });
        }
      }).catch(err => {
        //if error, log error, trigger snackbar
        console.error(err);
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', { text: "Search for bulbs to add this bulb did not work at this time", color: 'red', timeout: 6000 }, { root: true });
        commit('setPopoverDataLoading', false, { root: true });
      });

  },
  getBulbAnalytics: ({ commit, state, rootState }, data) => {
    commit('setBulbHasNoSummaryData', false);
    commit('setPopoverDataLoading', true, { root: true });
    // Sets data back to empty
    state.bulbAnalyticsSummaryChart.labels = [];
    state.bulbAnalyticsSummaryChart.datasets[0].data = [];
    state.bulbAnalyticsSummaryChart.datasets[1].data = [];
    state.bulbAnalyticsSummaryChart.datasets[2].data = [];
    state.bulbAverageScoreChart.datasets[0].data = [];
    state.bulbCompleteChart.datasets[0].data = [];
    //get bulb anlytics data
    axios.get(`${rootState.nodeApiPrefix}/instructor/bulbAnalytics?bulb_id=${data.bulb_id}&section_id=${data.section_id}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        // Check for Summary Data
        if (res.data.bulbAnalytics.bulbAnalyticsSummary.length === 0) {
          commit('setBulbHasNoSummaryData', true);
        } else {
          commit('setBulbHasNoSummaryData', false);
        }
        // Check for Average Score Data
        if (res.data.bulbAnalytics.bulbAverageScore[0].percent_100 === null
          && res.data.bulbAnalytics.bulbAverageScore[0].percent_75_up === null
          && res.data.bulbAnalytics.bulbAverageScore[0].percent_50_75 === null
          && res.data.bulbAnalytics.bulbAverageScore[0].percent_50_down === null) {
          commit('setBulbHasNoAverageData', true);
        } else {
          commit('setBulbHasNoAverageData', false);
        }
        // Check for Complete Data
        if (res.data.bulbAnalytics.bulbCompleteAnalytics[0].completed === null
          && res.data.bulbAnalytics.bulbCompleteAnalytics[0].started === null
          && res.data.bulbAnalytics.bulbCompleteAnalytics[0].unstarted === null) {
          commit('setBulbHasNoCompleteData', true);
        } else {
          commit('setBulbHasNoCompleteData', false);
        }

        // if success, sets assigned date data
        if (res.data.msg === "success") {
          commit('setBulbAnalytics', res.data.bulbAnalytics);
          commit('setPopoverDataLoading', false, { root: true });
        }
      }).catch(err => {
        //if error, log error, trigger snackbar
        console.error(err);
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', { text: "Unable to get bulb analytics for this bulb.", color: 'red', timeout: 6000 }, { root: true });
        commit('setPopoverDataLoading', false, { root: true });
      });

  },
  addBulbCoOwners: async ({ commit, state, rootState }, addUserGroup) => {
    try {
      commit('setSearchingForEmailMatch', true);
      const coOwners = await axios.post(`${rootState.nodeApiPrefix}/instructor/bulbCoOwners`, addUserGroup, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      commit('setBulbCoOwners', coOwners.data.addCoOwners);
      commit('setEmailMatchesFromSchool', []);
      commit('incrementCoOwnersKey');
      const accessLevel = addUserGroup.accessLevel === 2 ? 'Co-editor' : 'Facilitator';
      commit('triggerSnackbar', { text: `${accessLevel}(s) added!`, color: 'green', timeout: 5000 }, { root: true });
    } catch (e) {
      commit('triggerSnackbar', { text: e.response.data.message, color: 'red', timeout: 5000 }, { root: true });
    } finally {
      commit('setSearchingForEmailMatch', false);
    }
  },
  changeOwner: async ({ commit, state, rootState }, updateData) => {
    try {
      state.instructorAjaxing = true;
      if (updateData.isAdmin) {
        await axios.post(`${rootState.nodeApiPrefix}/instructor/bulbteacher/adminTransfer`,
          updateData,
          {
            headers: {
              'Authorization': `Bearer ${rootState.instructorData.token}`
            }
          });
      } else {
        await axios.post(`${rootState.nodeApiPrefix}/instructor/bulbteacher/transfer`,
          updateData,
          {
            headers: {
              'Authorization': `Bearer ${rootState.instructorData.token}`
            }
          });
      }
    } catch (e) {
      commit('triggerSnackbar', { text: 'Unable to update CoOwner.', color: 'red', timeout: 5000 }, { root: true });
    } finally {
      ;
      state.refreshData = true;
      state.instructorAjaxing = false;
    }
  },
  removeBulbCoOwners: ({ commit, state, rootState }, removeUserGroup) => {
    commit('setSearchingForEmailMatch', true);
    axios.post(`${rootState.nodeApiPrefix}/instructor/bulbCoOwners/remove`, removeUserGroup, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        commit('setEmailMatchesFromSchool', []);
        commit('incrementCoOwnersKey');
        commit('setSearchingForEmailMatch', false);
        commit('triggerSnackbar', { text: "Collaborator(s) removed!", color: 'green', timeout: 5000 }, { root: true });
      })
      .catch(e => {
        commit('setSearchingForEmailMatch', false);
        commit('triggerSnackbar', { text: e.response.data.message, color: 'red', timeout: 5000 }, { root: true });
      });
  },
  updateBulbCoOwners: async ({ commit, state, rootState }, updateData) => {
    try {
      commit('setSearchingForEmailMatch', true);
      const coOwnerData = await axios.put(`${rootState.nodeApiPrefix}/instructor/bulbCoOwners`, updateData, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      commit('resetBulbCoOwners');
      commit('setBulbCoOwners', coOwnerData.data.coOwners)
      commit('incrementCoOwnersKey');
    } catch (e) {
      commit('triggerSnackbar', { text: 'Unable to update CoOwner.', color: 'red', timeout: 5000 }, { root: true });
    } finally {
      commit('setSearchingForEmailMatch', false);
    }
  },
  lookForBulbCoOwners: ({ commit, state, rootState }, bulbId) => {
    axios.get(`${rootState.nodeApiPrefix}/instructor/bulbCoOwners?bulbId=${bulbId}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        commit('setBulbCoOwners', res.data.bulbOwners);
        commit('setSearchingForEmailMatch', false);
      })
      .catch(e => {
        dataLayer.axiosLog(e);
        commit('triggerSnackbar', { text: 'Error looking for CoOwners.', color: 'red', timeout: 5000 }, { root: true });
        commit('setSearchingForEmailMatch', false);
      });
  },
  async addPlaylistCoOwners({ commit, state, rootState }, addUserGroup) {
    try {
      commit('setSearchingForEmailMatch', true);
      const { data: addCoOwners } = await axios.post(`${rootState.nodeApiPrefix}/instructor/playlistCoOwners`,
        addUserGroup,
        {
          headers: {
            'Authorization': `Bearer ${rootState.instructorData.token}`
          }
        }
      );
      commit('setPlaylistCoOwners', addCoOwners);
      commit('setEmailMatchesFromSchool', []);
      commit('incrementCoOwnersKey');
      commit('triggerSnackbar', { text: "Co-editor(s) added!", color: 'green', timeout: 5000 }, { root: true });
    } catch (e) {
      commit('triggerSnackbar', { text: e.response.data.message, color: 'red', timeout: 5000 }, { root: true });
    } finally {
      commit('setSearchingForEmailMatch', false);
    }
  },
  async updatePlaylistCoOwners({ commit, state, rootState }, updateData) {
    try {
      commit('setSearchingForEmailMatch', true);
      const { data: coOwners } = await axios.put(`${rootState.nodeApiPrefix}/instructor/playlistCoOwners`,
        updateData,
        {
          headers: {
            'Authorization': `Bearer ${rootState.instructorData.token}`
          }
        }
      );
      commit('resetPlaylistCoOwners');
      commit('setPlaylistCoOwners', coOwners);
    } catch (e) {
      commit('triggerSnackbar', { text: 'Unable to update CoOwner.', color: 'red', timeout: 5000 }, { root: true });
    } finally {
      commit('setSearchingForEmailMatch', false);
    }
  },
  lookForPlaylistCoOwners: ({ commit, state, rootState }, playlistId) => {
    axios.get(`${rootState.nodeApiPrefix}/instructor/playlistCoOwners?playlistId=${playlistId}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        commit('setPlaylistCoOwners', res.data);
        commit('setSearchingForEmailMatch', false);
      })
      .catch(e => {
        dataLayer.axiosLog(e);
        commit('triggerSnackbar', { text: 'Error looking for CoOwners.', color: 'red', timeout: 5000 }, { root: true });
        commit('setSearchingForEmailMatch', false);
      });
  },
  searchForEmailMatches: ({ commit, state, rootState }, emailString) => {
    commit('setEmailMatchesFromSchool', []);
    commit('setSearchingForEmailMatch', true);
    axios.post(`${rootState.nodeApiPrefix}/instructor/searchSchoolForMatch`, { emailString }, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        if (res.data.emailMatches.length === 0) {
          commit('triggerSnackbar', { text: "Unable to find matches in your institution.", color: 'red', timeout: 5000 }, { root: true });
        }
        commit('setEmailMatchesFromSchool', res.data.emailMatches);
        commit('setSearchingForEmailMatch', false);
      })
      .catch(e => {
        dataLayer.axiosLog(e);
        commit('triggerSnackbar', { text: 'Unable to find any matches.', color: 'red', timeout: 5000 }, { root: true });
        commit('setSearchingForEmailMatch', false);
      });
  },
  async lookForClassCoOwners({
    commit,
    state,
    rootState,
  }, sectionId) {
    try {
      const res = await axios.get(
        `${rootState.nodeApiPrefix}/instructor/classCoOwners?sectionId=${sectionId}`,
        {
          headers: {
            Authorization: `Bearer ${rootState.instructorData.token}`,
          },
        },
      );
      commit('setClassCoOwners', res.data.classOwners);
      commit('setSearchingForEmailMatch', false);
    } catch (e) {
      dataLayer.axiosLog(e);
      commit('triggerSnackbar', {
        text: 'Error looking for CoOwners.',
        color: 'red',
        timeout: 5000
      },
        {
          root: true
        }
      );
      commit('setSearchingForEmailMatch', false);
    }
  },
  addClassCoOwners: async ({ commit, dispatch, state, rootState }, addUserGroup) => {
    try {
      commit('setSearchingForEmailMatch', true);
      const coOwnersQuery = await axios.post(`${rootState.nodeApiPrefix}/instructor/classCoOwners`, addUserGroup, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      const addedCoOwners = coOwnersQuery.data.addCoOwners;
      let counter = 0;
      let success = false;
      // timeout checks to see if bulbTeacher and teacherSection rows have been added
      const pingProxy = setInterval(async () => {
        if (counter > 24 || success) return clearInterval(pingProxy);
        const shareClassComplete = await axios.post(`${rootState.nodeApiPrefix}/instructor/pingClassCoOwners`, addUserGroup, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
        counter++;
        if (shareClassComplete.data.finishedSharingClass) {
          // if bulbTeacher and teacherSection rows are done display.
          success = true;
          commit('setClassCoOwners', addedCoOwners);
          commit('setEmailMatchesFromSchool', []);
          commit('incrementCoOwnersKey');
          commit('setSearchingForEmailMatch', false);
          commit('triggerSnackbar', { text: "Co-editor(s) added!", color: 'green', timeout: 5000 }, { root: true });
        }
      }, 5000);
    } catch (e) {
      commit('setSearchingForEmailMatch', false);
      commit('triggerSnackbar', { text: e.response.data.message, color: 'red', timeout: 5000 }, { root: true });
    }
  },
  updateClassCoOwners: ({ commit, state, rootState }, updateData) => {
    commit('setSearchingForEmailMatch', true);
    axios.put(`${rootState.nodeApiPrefix}/instructor/classCoOwners`, updateData, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        commit('resetClassCoOwners')
        commit('setClassCoOwners', res.data.coOwners)
        commit('setSearchingForEmailMatch', false);
      })
      .catch(e => {
        commit('setSearchingForEmailMatch', false);
        commit('triggerSnackbar', { text: 'Unable to update CoOwner.', color: 'red', timeout: 5000 }, { root: true });
      });
  },
  changeSectionOwner: async ({ commit, state, rootState }, updateData) => {
    try {
      state.instructorAjaxing = true;
      await axios.post(`${rootState.nodeApiPrefix}/instructor/class/transfer`, updateData, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
    } catch (e) {
      commit('triggerSnackbar', { text: 'Unable to update class permissions.', color: 'red', timeout: 5000 }, { root: true });
    } finally {
      ;
      state.refreshData = true;
      state.instructorAjaxing = false;
    }
  },
  getPlaylistSection: async ({ commit, state, rootState }, playlistData) => {
    commit('setPopoverDataLoading', true, { root: true });
    try {
      const playlistSection = await axios.get(`${rootState.nodeApiPrefix}/playlist/playlistsection/${playlistData.playlistId}/${playlistData.sectionId}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      return playlistSection.data;
    } catch (e) {
      commit('triggerSnackbar', {
        text: 'Trouble retrieving playlist section.',
        color: 'red',
        timeout: 5000
      },
        {
          root: true
        }
      );
    } finally {
      commit('setPopoverDataLoading', false, { root: true });
    }
  },
  updatePlaylistSection: async ({ commit, state, rootState }, updateData) => {
    commit('setPopoverDataLoading', true, { root: true });
    try {
      await axios.put(`${rootState.nodeApiPrefix}/playlist/playlistsection/${updateData.playlistId}/${updateData.sectionId}`, {
        newConfig: updateData.newConfig,
      }, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      commit('triggerSnackbar', {
        text: 'Playlist settings updated.',
        color: 'green',
        timeout: 5000
      },
        {
          root: true
        }
      );
    } catch (e) {
      commit('triggerSnackbar', {
        text: 'Trouble updating playlist.',
        color: 'red',
        timeout: 5000
      },
        {
          root: true
        }
      );
    } finally {
      commit('setPopoverDataLoading', false, { root: true });
    }
  },
  /**
   * Action that is invoked from this view:
   *
   * Classes => <class_name> => Manage Playlist
   */
  async managePlaylist(context, { playlistId, sectionId }) {
    try {
      state.dynamicDataLoaded = false;
      window.open(`${context.rootState.nodeApiPrefix}/course/${hashids.encode([playlistId, sectionId])}?token=${context.rootState.instructorData.token}`, '_blank');
      state.dynamicDataLoaded = true;
    } catch (e) {
      state.dynamicDataLoaded = true;
      context.commit('triggerSnackbar', { text: "Trouble launching Playlist.", color: 'red', timeout: 5000 }, { root: true });
      throw (e);
    }
  },
  removePlaylistAccess: async (context, playlistId) => {
    try {
      state.playlistModalLoading = true;
      state.instructorAjaxing = true;
      await axios.delete(`${context.rootState.nodeApiPrefix}/instructor/playlistCoOwners/${playlistId}`, { headers: { 'Authorization': `Bearer ${context.rootState.instructorData.token}` } });
    } catch (e) {
      context.commit('triggerSnackbar', { text: 'Error removing playlist access.', color: 'red', timeout: 6000 }, { root: true });
    } finally {
      context.commit('refreshData');
      state.playlistModalLoading = false;
      state.instructorAjaxing = false;
    }
  },
  duplicatePlaylist: async (context, playlistId) => {
    try {
      state.dynamicDataLoaded = false;
      state.instructorAjaxing = true;
      context.rootState.admin.adminAjaxing = true;
      const { data: { copiedPlaylistId } } = await axios.post(`${context.rootState.nodeApiPrefix}/instructor/duplicate-playlist/${playlistId}`, {},
        {
          headers: {
            'Authorization': `Bearer ${context.rootState.instructorData.token}`
          }
        });
      return copiedPlaylistId;
    } catch (e) {
      context.commit('triggerSnackbar', { text: 'Error duplicating playlist.', color: 'red', timeout: 6000 }, { root: true });
    } finally {
      context.commit('refreshData');
      state.instructorAjaxing = false;
      context.rootState.admin.adminAjaxing = false;
    }
  },
  addBulbToFolder: ({ commit, state, rootState }, obj) => {
    commit('setPopoverDataLoading', true, { root: true });
    //get assigned dates for bulb for all classes
    axios.get(`${rootState.nodeApiPrefix}/instructor/folders/${obj.folder_id}/bulbs/${obj.bulb_id}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        //if success, sets assigned date data
        if (res.data.msg === "success") {
          commit('setAddRemoveBulbFolder', { data: res.data.data, add: true });
          commit('setPopoverDataLoading', false, { root: true });
        }
      }).catch(err => {
        //if error, log error, trigger snackbar
        console.error(err);
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', { text: "Adding bulb to folder did not work at this time.", color: 'red', timeout: 6000 }, { root: true });
        commit('setPopoverDataLoading', false, { root: true });
      });
  },
  removeBulbToFolder: ({ commit, state, rootState }, obj) => {
    commit('setPopoverDataLoading', true, { root: true });
    //get assigned dates for bulb for all classes
    axios.delete(`${rootState.nodeApiPrefix}/instructor/folders/${obj.folder_id}/bulbs/${obj.bulb_id}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        //if success, sets assigned date data
        if (res.data.msg === "success") {
          commit('setAddRemoveBulbFolder', { data: res.data.data, add: false });
          commit('setPopoverDataLoading', false, { root: true });
        }
      }).catch(err => {
        //if error, log error, trigger snackbar
        console.error(err);
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', { text: "Removing bulb from folder did not work at this time.", color: 'red', timeout: 6000 }, { root: true });
        commit('setPopoverDataLoading', false, { root: true });
      });
  },
  copyFolder: ({ commit, state, rootState }, obj) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;
      commit('triggerSnackbar', { text: "Folder copying.", color: 'green', timeout: 0 }, { root: true });
      //post new class data
      axios.put(`${rootState.nodeApiPrefix}/instructor/folders/${obj.id}`, obj, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh and turn off ajaxing
          if (res.data.msg === "success") {
            rootState.snackbar.show = false;
            rootState.snackbar.text = '';
            rootState.snackbar.color = null;
            rootState.snackbar.action = '';
            rootState.snackbar.action_text = '';
            state.refreshData = true;
            state.instructorAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Copying folder did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
        });
    }
  },
  importUnits: ({ commit, state, rootState }) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;
      commit('triggerSnackbar', { text: "Unit import in progress.", color: 'green', timeout: 0 }, { root: true });
      //post new class data
      axios.get(`${rootState.nodeApiPrefix}/instructor/importunits`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh and turn off ajaxing
          if (res.data.msg === "success") {
            rootState.snackbar.show = false;
            rootState.snackbar.text = '';
            rootState.snackbar.color = null;
            rootState.snackbar.action = '';
            rootState.snackbar.action_text = '';
            state.refreshData = true;
            commit('updateUnitImport', {}, { root: true });
            state.instructorAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Importing units did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
        });
    }
  },
  archiveVideo: ({ commit, state, rootState }, id) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;

      //set data to class id
      let data = { id: id }
      //delete class id to archive class and all supporting tables
      axios.delete(`${rootState.nodeApiPrefix}/instructor/videos/${data.id}`, { data: data, headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh and turn off ajaxing
          if (res.data.msg === "success") {
            state.refreshData = true;
            state.instructorAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Deleting your video did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
        });
    }
  },
  archiveClass: ({ commit, state, rootState }, id) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;

      //set data to class id
      let data = {}
      //post class id to archive class and all supporting tables
      axios.delete(`${rootState.nodeApiPrefix}/instructor/classes/${id}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh and turn off ajaxing
          if (res.data.msg === "success") {
            state.refreshData = true;
            state.instructorAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Archiving your class did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
        });
    }
  },
  unarchiveClass: ({ commit, state, rootState }, obj) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;

      //set data to class id
      let data = {}
      //post class id to archive class and all supporting tables
      axios.put(`${rootState.nodeApiPrefix}/instructor/classes/${obj.id}`, data, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh and turn off ajaxing
          if (res.data.msg === "success") {
            state.refreshData = true;
            state.instructorAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Unarchiving your class did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
        });
    }
  },
  async deleteBulb({
    commit,
    state,
    rootState,
  } = {}, id) {
    try {
      if (state.instructorAjaxing) return;
      // Enable ajaxing boolean.
      state.instructorAjaxing = true;
      // If `id` is an array, convert to a comma-separated string.
      if (_.isArray(id)) id = id.join(',');
      const response = await axios.delete(
        `${rootState.nodeApiPrefix}/instructor/bulbs/${id}`,
        {
          headers: {
            Authorization: `Bearer ${rootState.instructorData.token}`,
          },
        },
      );
      // If success trigger refresh, and turn off ajaxing.
      if (_.get(response, 'data.msg') === "success") {
        state.refreshData = true;
        state.instructorAjaxing = false;
      }
    } catch (e) {
      // If error, log error, trigger snackbar, and turn off ajaxing.
      console.error(e);
      dataLayer.axiosLog(e);
      commit(
        'triggerSnackbar',
        {
          text: 'Deleting this bulb did not work at this time',
          color: 'red',
          timeout: 6000,
        },
        { root: true },
      );
      state.instructorAjaxing = false;
    }
  },
  removeAccess: ({ commit, state, rootState }, bulbId) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;
      // remove teacher from bulbTeacher table for given bulb
      axios.delete(`${rootState.nodeApiPrefix}/instructor/removeAccess/${bulbId}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh and turn off ajaxing
          if (res.data.msg === "success") {
            state.refreshData = true;
            state.instructorAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Removing access to this bulb did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
        });
    }
  },
  removeClassAccess: async ({ commit, state, rootState }, sectionId) => {
    try {
      state.instructorAjaxing = true;
      commit('setPopoverDataLoading', true, { root: true });
      await axios.delete(`${rootState.nodeApiPrefix}/instructor/class/removeAccess/${sectionId}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      state.instructorAjaxing = false;
      commit('setPopoverDataLoading', false, { root: true });
      commit('triggerSnackbar', { text: "Successfully removed access.", color: 'green', timeout: 5000 }, { root: true });
      commit('setDashModal', (null), { root: true });
      commit('refreshData');
    } catch (error) {
      state.instructorAjaxing = false;
      commit('triggerSnackbar', { text: "Error removing access.", color: 'red', timeout: 5000 }, { root: true });
      commit('setDashModal', (null), { root: true });
    }
  },
  rejoinClass: async ({ commit, state, rootState }, sectionId) => {
    try {
      state.instructorAjaxing = true;
      commit('setPopoverDataLoading', true, { root: true });
      await axios.put(`${rootState.nodeApiPrefix}/instructor/class/rejoin`, { sectionId }, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      commit('triggerSnackbar', { text: "Successfully rejoined class.", color: 'green', timeout: 5000 }, { root: true });
      commit('refreshData');
    } catch (error) {
      commit('triggerSnackbar', { text: "Error rejoining class.", color: 'red', timeout: 5000 }, { root: true });
    } finally {
      commit('setPopoverDataLoading', false, { root: true });
      commit('setDashModal', (null), { root: true });
      state.instructorAjaxing = false;
    }
  },
  async copyBulb({
    commit,
    state,
    rootState,
  } = {}, {
    name,
    id,
    fullCopy,
    lti,
    edit,
    refreshData,
    forceThrough,
    isCopyingUnrestricted,
    copyLmbData,
  } = {}) {
    try {
      if (
        state.instructorAjaxing
        && !forceThrough
      ) return false;
      state.instructorAjaxing = true;
      const { data } = await axios.post(
        `${rootState.nodeApiPrefix}/instructor/bulbs/${id}/copy${isCopyingUnrestricted ? '/unrestricted' : ''}`,
        {
          name,
          fullCopy,
          copyLmbData,
        },
        {
          headers: {
            Authorization: `Bearer ${rootState.instructorData.token}`,
          },
        },
      );
      if (lti) {
        state.refreshData = true;
        commit('resetLTIPopover', {
          reset: true,
          data: {
            name,
            id: data.id,
            lmb_id: null
          }
        }, { root: true });
      } else {
        commit('toggleToastLoader', {
          toggle: false,
          text: '',
        });
        commit('triggerSnackbar', {
          text: 'Bulb Copied',
          color: 'green',
          timeout: 5000
        }, { root: true });
        if (edit) {
          window.open(`${rootState.designerApiPrefix}/designer/?bulb_id=${data.id}&token=${rootState.instructorData.token}`, '_blank');
        }
      }
      state.refreshData = _.isNil(refreshData) ? true : refreshData; // default to refresh data unless specified
      return data;
    } catch (e) {
      dataLayer.axiosLog(e);
      commit('toggleToastLoader', {
        toggle: false,
        text: '',
      });
      commit('triggerSnackbar', {
        text: 'Copying this bulb did not work at this time',
        color: 'red',
        timeout: 6000
      }, { root: true });
      return _.get(e, 'response.data') || e;
    } finally {
      state.instructorAjaxing = false;
    }
  },
  assignBulbSection: async ({ commit, state, rootState }, obj) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;
      if (obj.assigned_date) {
        //assigned_date is date object with browser timezone
        //turn assigned date to string
        let dateString = moment(obj['assigned_date']).format("YYYY-MM-DD HH:mm:ss").toString();
        //format dateString to instructor timezone, then utc to save in db
        obj.assigned_date = moment.tz(dateString, rootState.instructorData.timezone).utc().format();
      }
      //post assigned date data
      return await axios.post(`${rootState.nodeApiPrefix}/instructor/bulb/${obj.bulb_id}/section/${obj.section_id}`, obj, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh, trigger success snackbar, and turn off ajaxing
          state.instructorAjaxing = false;
          state.assignedBulbSections[obj.section_id] = res.data.id;
          if (state.activeViewInstructor === 'Bulbs') {
            state.refreshData = true;
          }
          //add if modal is still open
          obj.modalOpen = rootState.popoverToggles.assignMenu;
        }).catch(err => {
          //if error, log error, trigger snackbar, refresh data to close modal, and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Assigning this bulb did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.instructorAjaxing = false;
        });
    }
  },
  unassignBulbSection: async ({ commit, state, rootState }, obj) => {
    if (!state.instructorAjaxing) {
      state.instructorAjaxing = true;
      const res = await axios.delete(`${rootState.nodeApiPrefix}/instructor/bulb/${obj.bulb_id}/section/${obj.section_id}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      state.assignedBulbSections[obj.section_id] = null;
      state.assignedGroupSets[obj.section_id] = null;
      state.refreshData = true;
      state.instructorAjaxing = false;
      return res;
    }
  },
  removeStudents: async ({ commit, state, rootState }) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      try {
        state.instructorAjaxing = true;
        //sets student array from selected data
        let studentArray = [];
        state.selectedData.forEach(item => studentArray.push(item.id));
        //delete student array and class id to remove students
        await axios.delete(`${rootState.nodeApiPrefix}/instructor/classes/${state.queryParamsInstructors.section_id}/learners`, { data: { students: studentArray, class_id: state.queryParamsInstructors.section_id }, headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
        state.refreshData = true;
        state.instructorAjaxing = false;
      } catch (err) {
        console.error(err);
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', { text: "Removing students did not work at this time", color: 'red', timeout: 6000 }, { root: true });
        state.selectedData = [];
        state.refreshData = true;
        state.instructorAjaxing = false;
      }
    }
  },
  moveStudents: ({ commit, state, rootState }, obj) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;

      //sets student array from selected data
      let studentArray = [];
      state.selectedData.forEach(item => studentArray.push(item.id));

      //post student arry and class id
      axios.post(`${rootState.nodeApiPrefix}/instructor/classes/${obj.class_from}/learners`, { students: studentArray, class_to: obj.class_to.id, class_from: obj.class_from }, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh, reset selected data and turn off ajaxing
          commit('triggerSnackbar', {
            text: `${res.data.created} Student${res.data.created > 1 ? 's' : ''} moved.`,
            color: res.data.created >= 0 ? 'success' : 'orange',
            timeout: 6000
          }, { root: true });
          state.selectedData = [];
          state.refreshData = true;
          state.instructorAjaxing = false;
        }).catch(err => {
          //if error, log error, trigger snackbar, refresh data to close modal, reset selected data, and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Moving students did not work at this time", color: 'red', timeout: 6000 }, { root: true });
          state.selectedData = [];
          state.refreshData = true;
          state.instructorAjaxing = false;
        });
    }
  },
  updateGrades: ({ commit, state, rootState }, data) => {
    //post update grade data
    axios.post(`${rootState.nodeApiPrefix}/instructor/interactionattempts/${data.interaction_attempt_id}`, data, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        if (state.activeViewInstructor === 'Interactions' || state.activeViewInstructor === 'Learner-Made-Bulb-Monitor') {
          //update score on bulb attempt
          commit('updateScore', res.data.data);
        } else {
          commit('reloadInteractionViewerIdToggle', null);
        }
      }).catch(err => {
        //if error, log error, trigger snackbar, and turn off ajaxing
        console.error(err);
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', { text: "Updating grades did not work at this time", color: 'red', timeout: 6000 }, { root: true });
        state.updateGradeAjaxing = false;
      });

  },
  updateLMBGrade: ({ commit, state, rootState }, data) => {
    //post update grade data
    axios.post(`${rootState.nodeApiPrefix}/instructor/learnermadebulbattempts/${data.bulb_attempt}`, data, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        //nothing needed to be done with successful response at this time
      }).catch(err => {
        //if error, log error, trigger snackbar, and turn off ajaxing
        console.error(err);
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', { text: "Updating grades did not work at this time", color: 'red', timeout: 6000 }, { root: true });
        state.updateGradeAjaxing = false;
      });

  },
  unlockLMB: ({ commit, state, rootState }, data) => {
    //post update grade data
    let postdata = {
      bulb_id: parseInt(state.queryParamsInstructors.bulb_id, 10),
      student_id: data.id
    }
    axios.put(`${rootState.nodeApiPrefix}/instructor/learnermadebulbattempts/${data.bulbattempt_id}`, postdata, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        //reset table data
        state.refreshData = true;
      }).catch(err => {
        //if error, log error, trigger snackbar, and turn off ajaxing
        console.error(err);
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', { text: "Updating grades did not work at this time", color: 'red', timeout: 6000 }, { root: true });
        state.updateGradeAjaxing = false;
      });

  },
  resetBulbAttempts: ({ commit, state, rootState }) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;
      //set bulb attempt array from selected data
      let bulbAttemptArray = [];
      state.selectedData.forEach(item => {
        if (item.bulbattempt_id) bulbAttemptArray.push(item.bulbattempt_id)
      });

      if (bulbAttemptArray.length > 0) {
        // post bulb attempt array
        axios.delete(`${rootState.nodeApiPrefix}/instructor/classes/any/bulbattempts`, { data: { bulb_attempts: bulbAttemptArray }, headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
          .then(res => {
            //if success trigger refresh, reset selected data and turn off ajaxing
            if (res.data.msg === "success") {
              state.selectedData = [];
              state.refreshData = true;
              state.instructorAjaxing = false;
            }
          }).catch(err => {
            //if error, log error, trigger snackbar, reset selected data, and turn off ajaxing
            console.error(err);
            dataLayer.axiosLog(err);
            commit('triggerSnackbar', { text: "Resetting bulb attempt did not work at this time", color: 'red', timeout: 6000 }, { root: true });
            state.selectedData = [];
            state.refreshData = true;
            state.instructorAjaxing = false;
          });
      } else {
        state.refreshData = true;
        state.selectedData = [];
        state.instructorAjaxing = false;
      }
    }
  },
  resetLMB: ({ commit, state, rootState }) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;
      //set bulb attempt array from selected data
      let array = [];
      state.selectedData.forEach(item => {
        if (item.bulbattempt_id) {
          array.push({ bulb_attempt: item.bulbattempt_id, bulb: item.lmb_bulb_id })
        }
      });

      //check if array has data before post
      if (array.length > 0) {
        // delete bulb attempt array
        axios.delete(`${rootState.nodeApiPrefix}/instructor/learnermadebulbattempts`, { data: { data: array }, headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
          .then(res => {
            //if success trigger refresh, reset selected data and turn off ajaxing
            if (res.data.msg === "success") {
              state.selectedData = [];
              state.refreshData = true;
              state.instructorAjaxing = false;
            }
          }).catch(err => {
            //if error, log error, trigger snackbar, reset selected data, and turn off ajaxing
            console.error(err);
            dataLayer.axiosLog(err);
            commit('triggerSnackbar', { text: "Resetting learner made bulb did not work at this time", color: 'red', timeout: 6000 }, { root: true });
            state.selectedData = [];
            state.refreshData = true;
            state.instructorAjaxing = false;
          });
      } else {
        state.selectedData = [];
        state.refreshData = true;
        state.instructorAjaxing = false;
      }
    }
  },
  //get popover data actions
  getAssignedDates: ({ commit, state, rootState }, id) => {
    commit('setAssignedDates', []);
    commit('setPopoverDataLoading', true, { root: true });
    //get assigned dates for bulb for all classes
    axios.get(`${rootState.nodeApiPrefix}/instructor/bulbs/${id}/classes`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        //if success, sets assigned date data
        if (res.data.msg === "success") {
          commit('setAssignedDates', res.data.data);
          commit('setPopoverDataLoading', false, { root: true });
        }
      }).catch(err => {
        //if error, log error, trigger snackbar
        console.error(err);
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', { text: "Search for bulbs to add this bulb did not work at this time", color: 'red', timeout: 6000 }, { root: true });
        commit('setPopoverDataLoading', false, { root: true });
      });

  },
  getBulbSections: async ({ commit, state, rootState }, bulbId) => {
    try {
      state.instructorAjaxing = true;
      const bsResponse = await axios.get(`${rootState.nodeApiPrefix}/instructor/bulb/${bulbId}/bulbsections`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      state.instructorAjaxing = false;
      return bsResponse.data;
    } catch (error) {
      state.instructorAjaxing = false;
      dataLayer.axiosLog(error);
      return [];
    }
  },
  getChartData: async ({ commit, state, rootState }, {
    interactionId,
    // interactionType,
    sectionId
  } = {}) => {
    try {
      state.instructorAjaxing = true;
      const chartData = await axios.get(`${rootState.nodeApiPrefix}/instructor/chart/${interactionId}/section/${sectionId}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      state.instructorAjaxing = false;
      return chartData.data;
    } catch (err) {
      dataLayer.axiosLog(err);
      return {
        level: err.response.data.level,
        name: err.response.data.name,
        message: err.response.data.message,
        correctCount: {},
        optionCount: {},
      }
    }
  },
  getDiscussionData: async ({ commit, rootState }, data) => {
    try {
      //get assigned dates for bulb for all classes
      return await axios.get(
        `${rootState.nodeApiPrefix}/neoplayer/discussion/${data.interactionId}/section/${data.sectionId}`,
        {
          headers: { 'Authorization': `Bearer ${data.token}` }
        });
    }
    catch (err) {
      //if error, log error, trigger snackbar
      console.error(err);
      dataLayer.axiosLog(err);
      commit('triggerSnackbar', { text: "Getting discussion data did not work at this time", color: 'red', timeout: 6000 }, { root: true });
    }
    
  },
  createLMB: async ({ commit, dispatch, state, rootState }, obj) => {
    if (!state.instructorAjaxing) {
      state.instructorAjaxing = true;
      try {

        const {
          nodeApiPrefix,
          instructorData: {
            token: instructorToken,
          },
          LTIlaunch,
          instructorType,
        } = rootState;

        const res = await axios.post(
          PLAYPOSIT_API_ENDPOINTS.createLMB({
            nodeApiPrefix,
          }),
          obj,
          {
            headers: {
              'Authorization': `Bearer ${instructorToken}`,
            }
          });
        if (res.data.msg === "success") {
          if (
            !LTIlaunch
            && instructorType === 'institutionLTI'
            && !res.data.data.rubric
          ) {
            //if institution lti user but not in a LTIlaunch
            commit('closeLMB', {}, { root: true });
          }
          else if (
            !LTIlaunch
            && !res.data.data.rubric
            && instructorType != 'institutionLTI'
          ) {
            commit('setAssignedDates', []);
            commit('setLMB', res.data, { root: true });
          }
          else if (
            LTIlaunch
            && !res.data.data.rubric
          ) {
            commit('setLMBlti', res.data, { root: true });
          }
          else {
            commit('setLMBrubric', res.data, { root: true });
            commit('slideOut', { toggle: true, view: 'rubric' }, { root: true });
          }
          state.refreshData = true;
          state.instructorAjaxing = false;
        }
      } catch (error) {
        dataLayer.errorLog(error.response);
        commit('triggerSnackbar',
        {
          text: "Creating Learner Made Bulb not working at this time.",
          color: 'red',
          timeout: 6000,
        }, {
          root: true,
        });
        state.refreshData = true;
        state.instructorAjaxing = false;
      }
    }
  },
  editLMB: ({ commit, state, rootState }, obj) => {
    if (!state.instructorAjaxing) {
      //turn on ajaxing boolean
      state.instructorAjaxing = true;

      axios.post(`${rootState.nodeApiPrefix}/instructor/learnermadebulbs/${obj.id}`, obj, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success trigger refresh, reset selected data and turn off ajaxing
          if (res.data.msg === "success") {
            if (!res.data.data.rubric) {
              state.refreshData = true;
              state.instructorAjaxing = false;
            } else {
              state.refreshData = true;
              state.instructorAjaxing = false;
              commit('triggerSnackbar', { text: "Opening rubric editor here", color: 'green', timeout: 6000 }, { root: true });
            }
          }
        }).catch(err => {
          //if error, log error, trigger snackbar, reset selected data, and turn off ajaxing
          console.error(err);
          dataLayer.errorLog(err.response);
          commit('triggerSnackbar', { text: "Editing Learner Made Bulb not working at this time.", color: 'red', timeout: 6000 }, { root: true });
          state.refreshData = true;
          state.instructorAjaxing = false;
        });
    }
  },
  checkLMBAttempts: ({ commit, state, rootState }, id) => {
    axios.get(`${rootState.nodeApiPrefix}/instructor/learnermadebulbs/${id}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        //if success trigger refresh, reset selected data and turn off ajaxing
        if (res.data.msg === "success") {
          commit('setEditLMBRubric', res.data.data);
        }
      }).catch(err => {
        //if error, log error, trigger snackbar, reset selected data, and turn off ajaxing
        console.error(err);
        dataLayer.errorLog(err.response);
        commit('triggerSnackbar', { text: "Checking if rubric editing is available did not work at this time.", color: 'red', timeout: 6000 }, { root: true });
      });
  },
  disableRubricLMB: ({ commit, state, rootState }) => {
    axios.get(`${rootState.nodeApiPrefix}/instructor/disablerubriclmb?id=${rootState.rubric_lmb_data.id}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        //if success trigger refresh, reset selected data and turn off ajaxing
        state.refreshData = true;
      }).catch(err => {
        //if error, log error, trigger snackbar, reset selected data, and turn off ajaxing
        console.error(err);
        dataLayer.errorLog(err.response);
        commit('triggerSnackbar', { text: "Disabling rubric grading on lmb did not work at this time.", color: 'red', timeout: 6000 }, { root: true });
      });

  },
  exportDataTable: async ({ commit, state, rootState }, obj) => {
    //data call to get all data for current active view and download as csv file
    //identify variables
    let type = obj.type;
    let bulb_id = (obj.bulb_id) ? obj.bulb_id : state.queryParamsInstructors.bulb_id;
    let section_id = (obj.section_id) ? obj.section_id : state.queryParamsInstructors.section_id;
    let playlist_id = (obj.playlist_id) ? obj.playlist_id : state.queryParamsInstructors.playlist_id;
    let learner_array = [];
    if (state.selectedData.length > 0) state.selectedData.forEach(item => learner_array.push(item.id));
    let array = JSON.stringify(learner_array)

    //create timestamp
    let timestamp = moment();
    if (
      rootState.school?.permissionKeys?.includes('enableBulbAnalyticsCsvStreaming')
      && type === 'Bulb-Analytics'
    ) {
      const { data: csvData } = await axios.get(`${rootState.nodeApiPrefix}/instructor/csv/bulb-analytics?bulbId=${bulb_id}&timezone=${rootState.instructorData.timezone}`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${rootState.instructorData.token}`,
        },
      });
      var blob = new Blob([csvData]);
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${obj.bulb_name}-All Bulb Attempts.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      commit('triggerSnackbar', { text: 'CSV export complete', color: 'green', timeout: 6000 }, { root: true });
      //turn off ajaxing
      state.instructorAjaxing = false;
      return;
    }
    axios.get(`${rootState.nodeApiPrefix}/instructor/csvexport/?bulb_id=${bulb_id}&section_id=${section_id}&interaction_id=${state.queryParamsInstructors.interaction_id}&student_id=${state.queryParamsInstructors.student_id}&folder_id=${state.queryParamsInstructors.folder_id}&type=${type}&timezone=${rootState.instructorData.timezone}&learner_array=${array}&timestamp=${timestamp}&playlist_id=${playlist_id}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        if (res.data.msg === "success") {
          let name;
          let className;
          state.classes.data.forEach(item => {
            if (item.id === state.queryParamsInstructors.section_id) {
              className = item.name;
            }
          })

          //create name based on type
          if (type === 'Learners') {
            //create unique name for bulbs and learners
            name = `${state.activeViewInstructor}-${className}`;
          } else if (type === 'Bulb-Analytics') {
            name = `${obj.bulb_name}-All Bulb Attempts`;
          } else if (type === 'Student-Bulb-Attempts') {
            name = `${state.activeViewInstructor}-${className}-${state.gradebookBreadcrumbs[0].text}`;
          } else if (type === 'Bulbs') {
            name = `${state.activeViewInstructor}-${className}`;
          } else if (type === 'My-Bulbs') {
            name = state.activeViewInstructor
          } else if (type === 'Gradebook' && state.activeViewInstructor === 'Gradebook') {
            name = `${state.activeViewInstructor}-${className}`;
          } else if (type === 'Gradebook' && state.activeViewInstructor === 'Classes') {
            let className;
            state.classes.data.forEach(item => {
              if (item.id === section_id) {
                className = item.name;
              }
            })
            name = `Gradebook-${className}`;
          } else if (type === 'Interactions') {
            let bulbName;
            if (rootState.LTIlaunch) {
              bulbName = rootState.LTIdata.contentName;
              state.classes.data.forEach(item => {
                if (item.id == rootState.LTIdata.section_id) {
                  className = item.name;
                  return className;
                }
              })
            } else {
              bulbName = state.gradebookBreadcrumbs[0] ? state.gradebookBreadcrumbs[0].text : bulb_id;
            }
            name = `Interactions-${bulbName}-${className}`;
          } else if (type === 'Single-Interaction') {
            //create name based on interaction id and type
            let interaction_type = '';
            let question_text = '';
            state.singleinteraction.data.forEach(item => {
              if (item.interaction_type) {
                interaction_type = item.interaction_type;
                question_text = item.interaction_text;
              }
            })
            name = `Single Interaction-${formatQuestionType(interaction_type)} (${question_text})`;
          } else if (type === 'Student-Interaction') {
            //create name based on student and bulb name
            name = `Student Interactions-${state.gradebookBreadcrumbs[1].text}-${state.gradebookBreadcrumbs[0].text}`;
          } else if (type === 'My-Bulbs-BA' || type === 'Bulbs-BA' || type === 'Remove-Access') {
            //create name
            let bulbName;
            state.bulbs.data.forEach(item => {
              if (item.id === obj.bulb_id) {
                bulbName = item.name;
              }
            })
            name = `Bulb Attempts-${bulbName}`;
          } else if (type === 'Learners-BA') {
            let studentNames = '';
            state.selectedData.forEach(item => studentNames += `${item.student_name}, `)
            name = `Bulb Attempts-${className}-${studentNames}`;
          } else {
            name = 'CSV-Export'
          }

          //take result, create a blob and download as csv
          var blob = new Blob([res.data.data]);
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${name}.csv`;
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
        //alert that export is completed
        commit('triggerSnackbar', { text: "CSV export complete", color: 'green', timeout: 6000 }, { root: true });
        //turn off ajaxing
        state.instructorAjaxing = false;

        //helper function to format question type
        function formatQuestionType(type) {
          switch (type) {
            case INTERACTION_TYPES.MULTIPLE_CHOICE:
              return 'Multiple Choice';
            case INTERACTION_TYPES.FREE_RESPONSE:
              return 'Free Response';
            case INTERACTION_TYPES.PAUSE:
              return 'Pause';
            case INTERACTION_TYPES.POLL:
              return 'Poll';
            case INTERACTION_TYPES.CHECK_ALL_APPLY:
              return 'Check All';
            case INTERACTION_TYPES.SHORT_ANSWER:
              return 'Fill in the Blank';
            case INTERACTION_TYPES.IFRAME:
              return 'Embedded';
            case INTERACTION_TYPES.FILE_VIEWER:
              return 'PDF Viewer';
            case INTERACTION_TYPES.DISCUSSION:
              return 'Discussion';
            default:
              return 'Question'
          }
        }
      }).catch(err => {
        console.error(err);
        state.instructorAjaxing = false;
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', { text: "CSV export not working at this time", color: 'red', timeout: 6000 }, { root: true });
      });

  },
  getBulbSection: async ({ rootState }, { bulbId, sectionId }) => {
    try {
      const { data: bulbSection } = await axios.get(`${rootState.nodeApiPrefix}/instructor/classes/${sectionId}/bulbs/${bulbId}`,
        {
          headers: {
            'Authorization': `Bearer ${rootState.instructorData.token}`,
          },
        },
      );
      return bulbSection;
    } catch (error) {
      return null;
    }
  },

  //legacy account actions


  importClassicBulbs: ({ commit, dispatch, state, rootState }) => {
    if (!state.instructorAjaxing) {
      state.instructorAjaxing = true;
      let timestamp = moment();
      axios.get(`${rootState.nodeApiPrefix}/instructor/migratelessonstobulbs?timestamp=${timestamp}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success
          if (res.data.msg === 'success') {
            state.instructorAjaxing = false;
            commit('toggleToastLoader', { toggle: false, text: '' });
            rootState.legacy.importedLessons = true;
            commit('triggerSnackbar', { text: "Bulb import in progress.", color: 'green', timeout: 0, action: 'openImportLog', action_text: 'Status' }, { root: true });
          } else if (res.data.msg === 'No classic bulbs found to import.') {
            commit('toggleToastLoader', { toggle: false, text: '' });
            rootState.legacy.importedLessons = true;
            state.instructorAjaxing = false;
            commit('triggerSnackbar', { text: "No classic bulbs found to import.", color: 'red', timeout: 6000 }, { root: true });
          } else if (res.data.msg === 'Bulb import in progress.') {
            commit('toggleToastLoader', { toggle: false, text: '' });
            state.instructorAjaxing = false;
            commit('triggerSnackbar', { text: "Bulb import in progress. Please wait.", color: 'red', timeout: 6000 }, { root: true });
          } else if (res.data.msg === 'Bulbs already imported.') {
            commit('toggleToastLoader', { toggle: false, text: '' });
            rootState.legacy.importedLessons = true;
            state.instructorAjaxing = false;
            commit('triggerSnackbar', { text: "Bulbs already imported.", color: 'green', timeout: 6000 }, { root: true });
          } else if (res.data.msg === 'Error') {
            commit('toggleToastLoader', { toggle: false, text: '' });
            rootState.legacy.importedLessons = true;
            rootState.legacy.showImportWarning = true;
            state.instructorAjaxing = false;
            commit('triggerSnackbar', { text: "Bulb import not working. Please contact PlayPosit support.", color: 'red', timeout: 6000 }, { root: true });
          }

        }).catch(err => {
          //if error, log error, trigger snackbar
          console.error(err);
          commit('toggleToastLoader', { toggle: false, text: '' });
          state.instructorAjaxing = false;
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', { text: "Importing classic bulbs did not work at this time.", color: 'red', timeout: 6000 }, { root: true });

        });
    }
  },
  activateBulb: ({ commit, state, rootState }, obj) => {
    if (!state.instructorAjaxing) {
      state.instructorAjaxing = true;
      let timestamp = moment();
      axios.get(`${rootState.nodeApiPrefix}/instructor/activatebulb?bulb_id=${obj.bulb_id}&lesson_id=${obj.lesson_id}&timestamp=${timestamp}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
        .then(res => {
          //if success
          if (res.data.msg === 'success') {
            commit('toggleToastLoader', { toggle: false, text: '' });
            commit('triggerSnackbar', { text: "Bulb activated.", color: 'green', timeout: 4000 }, { root: true });
            state.instructorAjaxing = false;
            state.refreshData = true;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar
          console.error(err);
          state.instructorAjaxing = false;
          dataLayer.axiosLog(err);
          commit('toggleToastLoader', { toggle: false, text: '' });
          commit('triggerSnackbar', { text: "Activating bulb did not work at this time.", color: 'red', timeout: 6000 }, { root: true });
        });
    }
  },
  getImportLogs: ({ commit, state, rootState }) => {
    state.importLogsLoading = true;
    let timestamp = moment();
    axios.get(`${rootState.nodeApiPrefix}/instructor/getimportlogs?timestamp=${timestamp}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } })
      .then(res => {
        //if success
        if (res.data.msg === 'No identity' || res.data.msg === 'Error') {
          rootState.legacy.showImportWarning = true;
          commit('setImportLogs', res.data.data);
        } else if (res.data.msg === 'In progress') {
          commit('setImportLogs', res.data.data);
          state.refreshData = true;
        } else if (res.data.msg === 'Complete') {
          commit('setImportLogs', res.data.data);
          rootState.snackbar.show = false;
          rootState.snackbar.text = '';
          rootState.snackbar.color = null;
          rootState.snackbar.action = '';
          rootState.snackbar.action_text = '';
          state.refreshData = true;
        }
      }).catch(err => {
        //if error, log error, trigger snackbar
        console.error(err);
        dataLayer.axiosLog(err);
        state.importLogsLoading = false;
        commit('triggerSnackbar', { text: "Getting bulb import data not working at this time.", color: 'red', timeout: 6000 }, { root: true });
      });

  },
  getGroups: async ({ commit, state, rootState }, groupSetId) => {
    try {
      commit('setPopoverDataLoading', true, { root: true });
      const res = await axios.get(`${rootState.nodeApiPrefix}/instructor/groupset/${groupSetId}/groups`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      return res.data;
    } catch (err) {
      dataLayer.axiosLog(err);
      commit('triggerSnackbar', { text: "Error fetching groups.", color: 'red', timeout: 6000 }, { root: true });
    } finally {
      commit('setPopoverDataLoading', false, { root: true });
    }
  },
  addGroup: async ({ commit, state, rootState }, { groupSetId, name }) => {
    try {
      commit('setPopoverDataLoading', true, { root: true });
      const res = await axios.post(`${rootState.nodeApiPrefix}/instructor/groupset/${groupSetId}/group`, { name }, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
    } catch (err) {
      dataLayer.axiosLog(err);
      commit('triggerSnackbar', { text: "Error adding group.", color: 'red', timeout: 6000 }, { root: true });
    } finally {
      commit('setPopoverDataLoading', false, { root: true });
    }
  },
  updateGroup: async ({ commit, state, rootState }, { groupSetId, groupId, name }) => {
    try {
      commit('setPopoverDataLoading', true, { root: true });
      const res = await axios.put(`${rootState.nodeApiPrefix}/instructor/groupset/${groupSetId}/group/${groupId}`, { name }, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
    } catch (err) {
      dataLayer.axiosLog(err);
      commit('triggerSnackbar', { text: "Error updating group.", color: 'red', timeout: 6000 }, { root: true });
    } finally {
      commit('setPopoverDataLoading', false, { root: true });
    }
  },
  deleteGroup: async ({ commit, state, rootState }, { groupSetId, groupId }) => {
    try {
      commit('setPopoverDataLoading', true, { root: true });
      const res = await axios.delete(`${rootState.nodeApiPrefix}/instructor/groupset/${groupSetId}/group/${groupId}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
    } catch (err) {
      dataLayer.axiosLog(err);
      commit('triggerSnackbar', { text: "Error deleting group.", color: 'red', timeout: 6000 }, { root: true });
    } finally {
      commit('setPopoverDataLoading', false, { root: true });
    }
  },  
  assignGroupStudent: async ({ commit, rootState }, { groupId, studentId }) => {
    try {
      commit(
        'setPopoverDataLoading',
        true,
        {
          root: true,
        }
      );
      await axios.post(
        `${rootState.nodeApiPrefix}/instructor/group/learner`,
        {
          groupId,
          learnerId: studentId,
        },
        {
          headers: {
            'Authorization': `Bearer ${rootState.instructorData.token}`,
          },
        }
      );
    } catch (error) {
      commit(
        'triggerSnackbar',
        {
          text: "Error assigning student.",
          color: 'red',
          timeout: 6000,
        },
        {
          root: true,
        }
      );
    } finally {
      commit(
        'setPopoverDataLoading',
        false,
        {
          root: true,
        }
      );
    }
  },
  deleteGroupStudent: async ({ commit, state, rootState }, { groupId, studentId }) => {
    // console.log('delete learner to group', groupId, studentId);
    try {
      commit('setPopoverDataLoading', true, { root: true });
      const res = await axios.delete(`${rootState.nodeApiPrefix}/instructor/group/${groupId}/learner/${studentId}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
    } catch (err) {
      dataLayer.axiosLog(err);
      commit('triggerSnackbar', { text: "Error deleting student from group.", color: 'red', timeout: 6000 }, { root: true });
    } finally {
      commit('setPopoverDataLoading', false, { root: true });
    }
  },
    
    
  getGroupSets: async ({ commit, state, rootState }) => {
    try {
      const res = await axios.get(`${rootState.nodeApiPrefix}/instructor/groupsets`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      state.groupSets = res.data;
    } catch (err) {
      console.error(err);
      dataLayer.axiosLog(err);
      commit('triggerSnackbar', { text: "Error fetching group sets.", color: 'red', timeout: 6000 }, { root: true });
    }
  },
  addGroupSet: async ({ commit, state, rootState }, { name, sectionId }) => {
    try {
      const res = await axios.post(`${rootState.nodeApiPrefix}/instructor/groupset`,
        { name, sectionId },
        { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      return res.data;
    } catch (err) {
      console.error(err);
      dataLayer.axiosLog(err);
      commit('triggerSnackbar', { text: "Error adding group set.", color: 'red', timeout: 6000 }, { root: true });
    } finally {
      commit('setPopoverDataLoading', false, { root: true });
    }
  },
  updateGroupSet: async ({ commit, state, rootState }, { groupSetId, name }) => {
    try {
      const res = await axios.put(`${rootState.nodeApiPrefix}/instructor/groupset/${groupSetId}`, { name }, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
    } catch (err) {
      console.error(err);
      dataLayer.axiosLog(err);
      commit('triggerSnackbar', { text: "Error updating group set.", color: 'red', timeout: 6000 }, { root: true });
    } finally {
      commit('setPopoverDataLoading', false, { root: true });
    }
  },
  deleteGroupSet: async ({ commit, state, rootState }, groupSetId) => {
    try {
      const res = await axios.delete(`${rootState.nodeApiPrefix}/instructor/groupset/${groupSetId}`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } });
      return true;
    } catch (err) {
      console.error(err);
      dataLayer.axiosLog(err);
      commit('triggerSnackbar', { text: _.get(err, 'response.data.message', 'Unable to delete Group Set.'), color: 'warning', timeout: 6000 }, { root: true });
      return false;
    } finally {
      commit('setPopoverDataLoading', false, { root: true });
    }
  },
  getLearnerGroups: ({ commit, state, rootState }, section_id) => {
    if (!rootState.popoverDataLoading) {
      commit('setPopoverDataLoading', true, { root: true })
      axios.get(`${rootState.nodeApiPrefix}/instructor/classes/${section_id}/groupsets`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } }).then(res => {
        //if success
        commit('setGroupData', res.data)
        commit('setPopoverDataLoading', false, { root: true })
      }).catch((err) => {
        //if error, log error, trigger snackbar
        console.error(err);
        dataLayer.axiosLog(err);
        commit('setPopoverDataLoading', false, { root: true })
        commit('triggerSnackbar', { text: "Importing canvas groups did not work at this time.", color: 'red', timeout: 6000 }, { root: true });
      });
    } else {
      commit('triggerSnackbar', { text: "Data loading. Please wait.", color: 'red', timeout: 6000 }, { root: true });
    }
  },
  getRubricInteractions: ({ commit, state, rootState }, id) => {

    axios.get(`${rootState.nodeApiPrefix}/instructor/learnermadebulbs/${id}/interactions`, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } }).then(res => {
      //if success
      if (res.data.msg === 'success') {
        res.data.edit = true;
        commit('setLMBrubric', res.data, { root: true });
        commit('slideOut', { toggle: true, view: 'rubric' }, { root: true });
      }
    }).catch((err) => {
      //if error, log error, trigger snackbar
      console.error(err);
      dataLayer.axiosLog(err);
      commit('triggerSnackbar', { text: "Evaluating this peer review did not work at this time.", color: 'red', timeout: 6000 }, { root: true });
    });
  },
  evaluatePeerReview: ({ commit, state, rootState }, obj) => {

    axios.post(`${rootState.nodeApiPrefix}/instructor/users`, {}, { headers: { 'Authorization': `Bearer ${rootState.instructorData.token}` } }).then(res => {
      //if success
      if (res.data.msg === 'success') {
        commit('setLearnerData', res.data.data, { root: true });
        window.open(`${rootState.playerApiPrefix}/player_v2/?section_id=${obj.lmb_section_id}&type=bulb&bulb_id=${obj.lmb_id}&token=${res.data.data.token}&lms_launch=${rootState.LTIlaunch}`)
      }
    }).catch((err) => {
      //if error, log error, trigger snackbar
      console.error(err);
      dataLayer.axiosLog(err);
      commit('triggerSnackbar', { text: "Evaluating this peer review did not work at this time.", color: 'red', timeout: 6000 }, { root: true });
    });
  },
  updatePlaylistCopySetting: async ({ commit, state, rootState }, playlist) => {
    try {
      state.instructorAjaxing = true;
      state.playlistModalLoading = true;
      await axios.patch(`${rootState.nodeApiPrefix}/playlist/settings`,
        {
          playlistId: playlist.id,
          facilitatorCopy: playlist.facilitatorCopy,
        },
        {
          headers: {
            'Authorization': `Bearer ${rootState.instructorData.token}`
          }
        });
      return playlist.facilitatorCopy;
    } catch (e) {
      commit('triggerSnackbar', {
        text: 'Error updating playlist copy setting.',
        color: 'warning',
        timeout: 6000
      },
        {
          root: true
        });
      return !playlist.facilitatorCopy;
    } finally {
      state.instructorAjaxing = false;
      state.playlistModalLoading = false;
    }
  },
  transferPlaylistOwner: async({state, commit, rootState}, data) => {
    try {
      state.instructorAjaxing = true;
      await axios.patch(`${rootState.nodeApiPrefix}/instructor/playlist/${data.playlistId}/transfer`,
        {
          newOwnerId: data.newOwnerId,
        },
        {
          headers: {
            'Authorization': `Bearer ${rootState.instructorData.token}`
          }
        });
    } catch (e) {
      commit('triggerSnackbar', {
        text: 'Error transferring playlist ownership.',
        color: 'warning',
        timeout: 6000
      },
        {
          root: true
        });
    } finally {
      state.instructorAjaxing = false;
      commit('setDashModal', (null), { root: true });
      state.refreshData = true;
    }
  },
  savePlaylistTags: async ({ commit, state, rootState }, playlist) => {
    try {
      state.instructorAjaxing = true;
      state.playlistModalLoading = true;
      const updatedPlaylist = await axios.post(`${rootState.nodeApiPrefix}/playlist/${playlist.id}/tags`,
        {
          addTags: playlist.addTags,
          deleteTags: playlist.deleteTags,
        },
        {
          headers: {
            'Authorization': `Bearer ${rootState.instructorData.token}`
          }
        });
      commit('triggerSnackbar', {
        text: 'Tags updated!',
        color: 'success',
        timeout: 6000,
        },
        {
          root: true,
        });
      return updatedPlaylist.data;
    } catch (e) {
      commit('triggerSnackbar', {
        text: 'Error updating playlist tags.',
        color: 'warning',
        timeout: 6000,
        },
        {
          root: true,
        });
    } finally {
      state.refreshData = true;
      commit('setDashModal', (null), { root: true });
      state.instructorAjaxing = false;
      state.playlistModalLoading = false;
    }
  },
}

const getters = {
    activeViewInstructor: state => state.activeViewInstructor,
    instructorAjaxing: state => state.instructorAjaxing,
    queryParamsInstructors: state => state.queryParamsInstructors,
    editGrades: state => state.editGrades,
    gradebookBreadcrumbs: state => state.gradebookBreadcrumbs,
    selectedData: state => state.selectedData,
    classes: state => state.classes,
    bulbs: state => state.bulbs,
    videos: state => state.videos,
    folders: state => state.folders,
    students: state => state.students,
    premade: state => state.premade,
    playlists: state => state.playlists,
    community: state => state.community,
    bulbattempts: state => state.bulbattempts,
    gradebook: state => state.gradebook,
    interactions: state => state.interactions,
    studentbulbattempts: state => state.studentbulbattempts,
    instructorBatchLoading: state => state.instructorBatchLoading,
    singleinteraction: state => state.singleinteraction,
    studentinteraction: state => state.studentinteraction,
    dynamicDataLoaded: state => state.dynamicDataLoaded,
    refreshData: state => state.refreshData,
    assignedBulbSections: state => state.assignedBulbSections,
    assignedDates: state => state.assignedDates,
    assignedGroupSets: state => state.assignedGroupSets,
    assignedDatesOriginal: state => state.assignedDatesOriginal,
    copyBulbLoader: state => state.copyBulbLoader,
    filterSearch: state => state.filterSearch,
    tags: state => state.tags,
    filterString: state => state.filterString,
    toastLoader: state => state.toastLoader,
    importLogs: state => state.importLogs,
    importLogsLoading: state => state.importLogsLoading,
    lmb: state => state.lmb,
    editLMBRubric: state => state.editLMBRubric,
    groups: state => state.groups,
    groupSets: state => state.groupSets, 
    peerreview: state => state.peerreview,
    foldersBulb: state => state.foldersBulb,
    singlefolder: state => state.singlefolder,
    subfolder: state => state.subfolder,
    reloadInteractionViewerId : state => state.reloadInteractionViewerId ,
    filtersInteraction: state => state.filtersInteraction,
    bulbRoles: state => ['Owner', 'Co-Editor', 'Facilitator'],
    playlistRoles: state => ['Owner', 'Co-Editor', 'Facilitator'],
    playlistHash: (state, getters, rootState) => hashids.encode([rootState.LTIdata.contentId, parseInt(rootState.LTIdata.section_id, 10)]),
    hasCustomLtiDash: (state, getters, rootState) => _.get(rootState.school, 'permissionKeys', []).includes('customLtiDash'),
    hasSamlLogin: (state, getters, rootState) => _.get(rootState.school, 'permissionKeys', []).includes('hasSamlLogin'),
    hasInstructorLearnerSchoolInGradebook: (state, getters, rootState) => rootState.school?.permissionKeys?.includes('hasInstructorLearnerSchoolInGradebook'),
    showFolderBatchSelection: (state, getters, rootState) => rootState.school?.permissionKeys?.includes('showFolderBatchSelection'),
    /**
     * Determine if the idp_url_learner urls are valued
     * 
     * If the idp_url_learner it set on the current school level or the idp_url is not set on the current school level AND the school 
     *  has a master district with the idp_url_learner populated then return true to add the type learner to the url.
     *  This logic matches the logic on the php SamlIntergration::getSchoolIdpUrl function.
     * 
     * @returns {Boolean} True if the idp_url_learner is defined on the school level or master school level if the idp urls on 
     *    the current school are not defined.
     */
    hasIdpLearnerUrl(state, getters, rootState) {
      if(
        _.get(rootState.school, 'config.idp_url_learner', null) !== null
        || (
          _.get(rootState.school, 'idp_url', null) === null
          && _.get(rootState.school, 'master_district.config.idp_url_learner', null) !== null
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
};

/**
 * This modifies the returned bulb array to add the linked piece of LTI content as the first bulb to display in the list.
 *
 * @param {Object} object bulb data object sent back from the server.
 */
function filterLtiLinkedContent(object) {
  if (object?.ltiData?.contentId) {
    const ltiLinkedContentIndex = _.findIndex(object?.data?.data, (content) => content.id === object?.ltiData?.contentId);
    if (ltiLinkedContentIndex < 0) return;
    const ltiLinkedContent = object.data.data[ltiLinkedContentIndex];
    object.data.data.splice(ltiLinkedContentIndex, 1);
    object.data.data.unshift(ltiLinkedContent);
  }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}